import React, { useState, useEffect, useRef, useMemo } from 'react'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import { connect, useSelector } from 'react-redux'
import { useParams, useHistory } from "react-router-dom";
import HttpService from '../../../services/httpService'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, Typography, Paper, Grid, Divider, Button, Table, TableBody, TableCell, TableContainer, TableRow, Box, Tooltip } from '@material-ui/core';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import AttachmentIcon from '@material-ui/icons/Attachment';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import PhotoIcon from '@material-ui/icons/Photo';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import DescriptionIcon from '@material-ui/icons/Description';
// import './index.css';
import { ROLENAME, constantDepartmentId, maskPhoneNumbersInLogText } from '../../../utils/index';
import { EditorState, convertToRaw } from 'draft-js';
import Editor from '@draft-js-plugins/editor';
import createMentionPlugin, { defaultSuggestionsFilter, } from '@draft-js-plugins/mention';
import '@draft-js-plugins/mention/lib/plugin.css';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { Checkbox, FormControlLabel, Card, CardContent, FormLabel, Chip, CircularProgress } from '@material-ui/core';
import { Alert } from "@material-ui/lab";
import SendIcon from "@material-ui/icons/Send";
import CryptoJs from 'crypto-js';
import LockIcon from '@material-ui/icons/Lock';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Grow from '@material-ui/core/Grow';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ChatIcon from '@material-ui/icons/Chat';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightBold,
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dialogPaper: {
        minWidth: "20%"
    },
    modalpaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    textFieldWidth: {
        width: "100%"
    },
    viewButton: { backgroundColor: 'white', color: '#14419c', borderRadius: '20px', marginLeft: '0.2em', "&:hover": { backgroundColor: "#14419c", color: 'white' } },

    otpCard: {
        marginTop: 15,
        marginBottom: 20,
        maxWidth: 420,
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 4px 18px rgba(244,126,68,0.18)",
        border: "1px solid #fbe0d3",
    },
    otpCardHeader: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "14px 18px",
        background: "linear-gradient(135deg, #F47E44 0%, #c1531f 100%)",
        color: "#fff",
    },
    otpCardBody: {
        padding: "16px 18px",
    },
    otpVerifiedBanner: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 18px",
        background: "#e6f4ea",
        color: "#1e7e34",
        fontWeight: 600,
    },
    otpInputBox: {
        letterSpacing: 6,
        fontWeight: 700,
        fontSize: 20,
        textAlign: "center",
    },
    otpSendButton: {
        borderRadius: 22,
        fontWeight: 600,
        textTransform: "none",
        background: "#F47E44",
        color: "#fff",
        "&:hover": { background: "#d9652c" },
    },
    otpVerifyButton: {
        borderRadius: 22,
        fontWeight: 600,
        textTransform: "none",
        // Brand orange (sampled from the Decorpot logo mark), replacing the
        // default MUI primary blue this button used to inherit.
        color: "#F47E44",
        borderColor: "#F47E44",
        "&:hover": {
            borderColor: "#d9652c",
            background: "rgba(244,126,68,0.08)",
        },
        "&:disabled": {
            color: "rgba(244,126,68,0.5)",
            borderColor: "rgba(244,126,68,0.3)",
        },
    },
    inlineLoaderRow: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginTop: 8,
        marginBottom: 8,
        color: "#716ACA",
        fontWeight: 500,
    },

    // ---- Update Execution Status modal redesign ----
    updateModalPaper: {
        borderRadius: 20,
        boxShadow: "0 20px 60px rgba(217,101,44,0.25)",
        overflow: "hidden",
        [theme.breakpoints.down('xs')]: {
            margin: 12,
            borderRadius: 16,
        },
    },
    updateModalHeader: {
        display: "flex",
        alignItems: "flex-start",
        gap: 14,
        padding: "22px 28px",
        background: "linear-gradient(135deg, #c1531f 0%, #F47E44 60%, #ff9c66 100%)",
        color: "#fff",
    },
    updateModalHeaderIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 44,
        height: 44,
        borderRadius: 12,
        background: "rgba(255,255,255,0.18)",
        flexShrink: 0,
    },
    updateModalHeaderTitle: {
        fontSize: 20,
        fontWeight: 700,
        color: "#fff",
        lineHeight: 1.3,
    },
    updateModalHeaderSubtitle: {
        fontSize: 13,
        color: "rgba(255,255,255,0.85)",
        marginTop: 2,
    },
    updateModalCloseBtn: {
        marginLeft: "auto",
        color: "#fff",
        transition: "background-color 200ms ease, transform 200ms ease",
        "&:hover": {
            backgroundColor: "rgba(255,255,255,0.18)",
            transform: "rotate(90deg)",
        },
    },
    updateModalContent: {
        padding: "28px 28px 8px",
        [theme.breakpoints.down('xs')]: {
            padding: "20px 16px 4px",
        },
    },
    updateModalFormWrap: {
        transition: "opacity 250ms ease",
    },
    sectionCard: {
        padding: 24,
        borderRadius: 16,
        marginTop: 20,
        marginBottom: 4,
        border: "1px solid #eceff3",
        background: "#fbfcfe",
    },
    sectionCardTitle: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 16,
        fontWeight: 700,
        color: "#c1531f",
        marginBottom: 18,
    },
    subSectionTitle: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        fontSize: 14,
        fontWeight: 600,
        color: "#d9652c",
        margin: "22px 0 12px",
    },
    uploadButtonPill: {
        borderRadius: 24,
        textTransform: "none",
        fontWeight: 600,
        boxShadow: "none",
        padding: "10px 20px",
        transition: "transform 200ms ease, box-shadow 200ms ease",
        "&:hover": {
            boxShadow: "0 6px 16px rgba(244,126,68,0.35)",
            transform: "translateY(-1px)",
        },
    },
    uploadRow: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        marginBottom: 12,
        flexWrap: "wrap",
    },
    iconCircleBtn: {
        borderRadius: "50%",
        padding: 8,
        transition: "background-color 200ms ease, transform 200ms ease",
        "&:hover": {
            transform: "scale(1.08)",
        },
    },
    updateModalActions: {
        padding: "18px 28px 24px",
        gap: 12,
    },
    primaryActionBtn: {
        borderRadius: 24,
        textTransform: "none",
        fontWeight: 700,
        minWidth: 150,
        height: 44,
        boxShadow: "none",
        // Overrides the MUI default primary (indigo) that `color="primary"`
        // would otherwise apply, same override pattern as otpSendButton.
        background: "#F47E44",
        color: "#fff",
        transition: "transform 200ms ease, box-shadow 200ms ease",
        "&:hover:not(.Mui-disabled)": {
            background: "#d9652c",
            boxShadow: "0 8px 20px rgba(244,126,68,0.35)",
            transform: "translateY(-1px)",
        },
        // Clearly greyed-out, not just a lighter orange - a faded orange at
        // full saturation still reads as "enabled" at a glance.
        "&.Mui-disabled": {
            background: "rgba(0, 0, 0, 0.12)",
            color: "rgba(0, 0, 0, 0.38)",
            boxShadow: "none",
        },
    },
    secondaryActionBtn: {
        borderRadius: 24,
        textTransform: "none",
        fontWeight: 600,
        minWidth: 110,
        height: 44,
        // Overrides the MUI default secondary (pink) that `color="secondary"`
        // would otherwise apply, keeping Cancel on the same orange theme but
        // outlined so it still reads as the lower-emphasis action next to Submit.
        color: "#c1531f",
        borderColor: "#F47E44",
        transition: "background-color 200ms ease, transform 200ms ease",
        "&:hover": {
            borderColor: "#d9652c",
            backgroundColor: "rgba(244,126,68,0.08)",
            transform: "translateY(-1px)",
        },
    },
}));


const ManageExecutionProjectLogs = (props) => {
    const classes = useStyles();

    const history = useHistory();
    const editorRef = useRef();
    const { projectId, pageName } = useParams();
    const { userDetails } = useSelector(state => state.user)
    const [projectDetails, setProjectDetails] = useState([]);
    const [projectLogs, setProjectLogs] = useState([]);
    const [openNotesModal, setOpenNotesModal] = useState(false);
    const createNoteFile = useRef()
    const [fileUploaded, setFileUploaded] = useState(false);
    const [departmentLists, setDepartmentsList] = useState([]);
    const [clicked, setClicked] = useState(false);
    const [selectedStage, setSelectedStage] = useState("");
    const [execution, setExecution] = useState([{ status: "Under Execution" }, { status: "Completed-MWP" }, { status: "Completed" }])
    const [executionStage, setExecutionStage] = useState("Update")
    const [executionCompletionDate, setExecutionCompletionDate] = useState(null);
    // const [executionCompletionRemarks, setExecutionCompletionRemarks] = useState("")
    const [executionMWPDate, setExecutionMWPDate] = useState(null)
    const [clientdependency, setClientDependency] = useState("")
    const [department, setSelectedDepartment] = useState("");
    const [team, setSelectedTeam] = useState("");
    const [dealOwner, setSelectedDealOwner] = useState("");
    const [teamLists, setTeamList] = useState([]);
    const [dealOwnerLists, setDealOwnersList] = useState([]);
    const [departmentStage, setDepartmentsStage] = useState([]);
    const [openMoveDealDetailsDialog, setOpenMoveDealDetailsDialog] = useState(false)
    const [selectedUser, setSelectedUser] = useState({});
    const [userModel, setUserModel] = useState(false)
    const [usersData, setUsersData] = useState([])
    const [elUsersOptions, setElUsersOptions] = useState([])
    const [pmUsersOptions, setPmUsersOptions] = useState([])
    const [selectedElUser, setSelectedElUser] = useState('')
    const [selectedPmUser, setSelectedPmUser] = useState('')
    const [completetionCertificate, setCompletetionCertificate] = useState([]);
    const [pics, setPics] = useState([""]);
    const [selectedLeadLogViewDetails, setSelectedLeadLogViewDetails] = useState({ noteUserName: '', noteUserContact: '', noteUserEmail: '', note: '', assistantManagerName: '', assistantManagerMobile: '', assistantManagerEmail: '', attachment: '' });
    const [openWhatsAppNotificationContentDialog, setOpenWhatsAppNotificationContentDialog] = useState(false);
    const [whatsAppNotificationContent, setWhatsAppNotificationContent] = useState('');
    const [formData, setFormData] = useState({
        notes: "",
        reminderDate: "",
        s3Location: "",
        projectId: "",
        user: "",
        stage: ""
    })
    const [daysfromModulardelivery, setDaysFromModularDelivery] = useState("")
    const [daysfromContractsign, setDaysFromContractSign] = useState("");

    const [file, setFile] = useState(null);
    const [extractResponse, setExtractResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isPdfValidated, setIsPdfValidated] = useState(false);

    // The customer's number leaks through fields nobody thought to mask:
    // automation-created leads are NAMED after it ("AI Bot Lead 7013184040") and
    // EMAILED at it ("7013184040@leads.decorpot.com"), so the Contact row can be
    // correctly masked while the two rows above hand the number over in full.
    //
    // Derived once so the rows can never disagree. Display only - every payload,
    // filename and API call still uses projectDetails.customerId.* untouched.
    const customerContactNo = projectDetails?.customerId?.contact_no;
    const maskedCustomerName = maskPhoneNumbersInLogText(
        projectDetails?.customerId?.name, customerContactNo
    );
    const maskedCustomerEmail = maskPhoneNumbersInLogText(
        projectDetails?.customerId?.email, customerContactNo
    );

    useEffect(() => {
        getProjectLogs();
        getcustomerDetails();
        imosDataOfStartandEnd()
        // eslint-disable-next-line
    }, [])

    const MessageComponent = ({ name, message }) => {
        const ipAddress = process.env.UI_IP || 'https://erp.decorpot.com/'
        const salesChecklistLinkPath = `${ipAddress}customer-check-lists-item/${projectDetails._id}`
        const salesChecklistLink = salesChecklistLinkPath
            ? `<a href="${salesChecklistLinkPath}" target="_blank">${salesChecklistLinkPath}</a>`
            : 'NA';
        const attachmentInfo = selectedLeadLogViewDetails.attachment
            ? `Attachment: <a href="${selectedLeadLogViewDetails.attachment}" target="_blank">${selectedLeadLogViewDetails.attachment}</a>`
            : 'Attachment: NA';
        const notesContentWithAttachment = `<br /><p>${selectedLeadLogViewDetails.note}</p><br />${attachmentInfo}`;
        let formattedMessage = message.replace('{{name}}', `<strong>${name}</strong>`)
            .replaceAll('{{leadOwnerName}}', `<i>${selectedLeadLogViewDetails.noteUserName}</i>`)
            .replace('{{customer}}', `<strong>${name}</strong>`)
            .replace('{{leadOwnerContact}}', `<i>${selectedLeadLogViewDetails.noteUserContact}</i>`)
            .replace('{{leadOwnerEmail}}', `<i>${selectedLeadLogViewDetails.noteUserEmail}</i>`)
            .replace('{{date}}', `<i>${moment(projectDetails?.materialDispatchedDate).format('DD-MM-YYYY')}</i>`)
            .replace('{{materialSelectionDate}}', `<i>${moment(projectDetails?.materialSelectionDate).format('DD-MM-YYYY')}</i>`)
            .replace('{{materialSelectionTime}}', `<i>${projectDetails.materialSelectionTime ? moment(projectDetails.materialSelectionTime, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
            .replace('{{intial_measurement_date}}', `<i>${moment(projectDetails?.intial_measurement_date).format('DD-MM-YYYY')}</i>`)
            .replace('{{intial_measurement_time}}', `<i>${projectDetails.intial_measurement_time ? moment(projectDetails.intial_measurement_time, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
            .replace('{{dateOfKickOffMeeting}}', `<i>${moment(projectDetails?.dateOfKickOffMeeting).format('DD-MM-YYYY')}</i>`)
            .replace('{{timeOfKickOffMeeting}}', `<i>${projectDetails.timeOfKickOffMeeting ? moment(projectDetails.timeOfKickOffMeeting, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
            .replace('{{siteQcDate}}', `<i>${moment(projectDetails?.siteQcDate).format('DD-MM-YYYY')}</i>`)
            .replace('{{siteQcTime}}', `<i>${projectDetails.siteQcTime ? moment(projectDetails.siteQcTime, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
            .replace('{{pocName}}', `<i>${selectedLeadLogViewDetails.noteUserName}</i>`)
            .replace('{{managerName}}', `<i>${selectedLeadLogViewDetails.assistantManagerName || 'NA'}</i>`)
            .replace('{{pocContact}}', `<i>${selectedLeadLogViewDetails.noteUserContact}</i>`)
            .replace('{{managerContact}}', `<i>${selectedLeadLogViewDetails.assistantManagerMobile || 'NA'}</i>`)
            // .replace('{{notesContent}}', `<br /><p>${selectedLeadLogViewDetails.note}</p><br />`)
            .replace('{{notesContent}}', notesContentWithAttachment)
            .replace('{{salesChecklistLink}}', `<br /><p>${salesChecklistLink || 'NA'}</p><br />`);

        const bubbleStyle = {
            backgroundColor: '#dcf8c6',
            padding: '10px 15px',
            borderRadius: '15px',
            marginBottom: '10px',
            maxWidth: '300px',
            position: 'relative',
            fontFamily: 'Arial, sans-serif',
            fontSize: '14px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
            margin: '20px auto',
            wordWrap: 'break-word',
            overflowWrap: 'break-word'
        };

        const tailStyle = {
            position: 'absolute',
            bottom: '0',
            left: '-10px',
            width: '0',
            height: '0',
            borderTop: '10px solid transparent',
            borderBottom: '10px solid transparent',
            borderRight: '10px solid #dcf8c6',
        };

        return (
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <div style={bubbleStyle}>
                    {formattedMessage.split('\n').map((line, index) => (
                        <p key={index} dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}></p>
                    ))}
                    <div style={tailStyle}></div>
                </div>
            </div>
        );
    };

    const getProjectLogs = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getProjectLog(projectId)
            setProjectLogs(response.data)
        } catch (error) {
            console.log("No logs found")
        }
        props.setLoading(false)
    }

    const getcustomerDetails = async () => {
        props.setLoading(true)
        getCurrentDate();
        try {
            const response = await HttpService.getProjectLeadDetails(projectId)
            setProjectDetails(response.data[0])
            let date = new Date()
            if (response.data[0].designSignOffDate) {
                let str = moment(response.data[0]?.designSignOffDate).valueOf()
                let time_difference = date.getTime() - str
                let result = time_difference / (1000 * 60 * 60 * 24);
                setDaysFromContractSign(result);
            }
            if (response.data[0]?.materialDispatchedDate) {
                let materialdispatch = moment(response.data[0]?.materialDispatchedDate).valueOf()
                let materialDiff = date.getTime() - materialdispatch
                let materialResult = materialDiff / (1000 * 60 * 60 * 24);
                setDaysFromModularDelivery(materialResult)
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getCurrentDate = () => {
        let projectMoveDate = new Date();
        let store = moment(projectMoveDate).format('MM-DD-YYYY');
        setExecutionMWPDate(store);
        setExecutionCompletionDate(store)
    }
    const [imosDrawingDateToFactory, setImosDrawingDateToFactory] = useState("")
    const imosDataOfStartandEnd = async () => {
        try {
            props.setLoading(true)
            const response = await HttpService.getDetailsOfImosProject(projectId);
            if (response.length !== 0) {
                let date = new Date()
                let startDate = moment(response.data[0]?.startedDate).valueOf()
                let endDate = moment(response.data[0]?.endDate).valueOf()
                let time_difference = endDate - startDate;
                let result = time_difference / (1000 * 60 * 60 * 24);
                setImosDrawingDateToFactory(result);
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }
    const openCreateNotesModal = () => {
        getAllUsers();
        setOpenNotesModal(true);
        setFormData({
            ...formData,
            user: projectDetails?.assignTo?._id,
            leadId: projectId
        })
    }

    const [openMailModel, setOpenMailModel] = useState(false);
    const [openUpdateModel, setOpenUpdateModel] = useState(false)
    const [sendMailCustomerData, setSendMailCustomerData] = useState({
        finalSubmitDate: "",
        amountDue: ""
    });

    const [updatestatus, setupdatestatus] = useState({
        materialDispatchedDate: "",
        status: "Under Execution"
    });
    const sendMailToCustomer = () => {
        setOpenMailModel(true);
    }
    const viewCheckList = () => {
        props.history.push(`/view-customer-checklist/${projectId}`);
    }

    const sendEmailToCustomer = async () => {
        // console.log(sendMailCustomerData, "sendMailCustomerData")
        props.setLoading(true)
        sendMailCustomerData.leadId = projectId;
        sendMailCustomerData.customerEmail = projectDetails.customerId?.email;
        sendMailCustomerData.customerName = projectDetails.customerId?.name;
        try {
            const response = await HttpService.sendFinalEmailToCustomer(sendMailCustomerData)
            props.setSnackInfo("Email Send to customer", "success")
            setOpenMailModel(false)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const changeStatusUnderExecution = async () => {
        // Check if all required fields are present when status is "Completed"
        if (executionStage.status == "Completed" &&
            (!executionCompletionDate ||
                !completionCertificate || // Check for completion certificate
                photoUrls.length === 0 ||
                videoUrls.length === 0 ||
                whatsappUrls.length === 0)) {
            props.setSnackInfo("Please Upload All Documents", "warning");
            return;
        }

        if (executionStage.status == "Completed-MWP" && !completionCertificate) {
            props.setSnackInfo("Please Upload Completion Certificate", "warning");
            return;
        }

        // Customer OTP is only required for the final "Completed" handover,
        // not for "Completed-MWP" - the customer isn't asked to verify an
        // OTP at the MWP stage.
        if (executionStage.status == "Completed" && !certificateOtpVerified) {
            props.setSnackInfo("Please verify the customer OTP before proceeding", "warning");
            return;
        }

        setClicked(true);
        let data = {};

        // Format completion certificate as expected by the backend
        const formattedCertificate = {
            notes: "",
            projectId: projectId || "",
            reminderDate: "",
            s3Location: completionCertificate,
            stage: "",
            user: ""
        };
        if (executionStage.status == "Completed") {
            data = {
                status: executionStage.status,
                leadId: projectId,
                // clientDependency: clientdependency,
                executionCompletionRemarks: executionCompletionRemarks,
                executionCompletionDate: executionCompletionDate,
                completetionCertificate: formattedCertificate,
                // Add media URLs to the payload
                photoUrls: photoUrls,
                videoUrls: videoUrls
            };
            // Add whatsapp URLs to the payload
            if (whatsappUrls.length) {
                data.whatsAppPics = whatsappUrls;
            }
        }
        else {
            data = {
                status: executionStage.status,
                leadId: projectId,
                executionMWPDate: executionMWPDate,
                completetionCertificate: formattedCertificate,
            };
        }

        props.setLoading(true);
        try {
            let response;

            if (selectedElUser?._id || selectedPmUser?._id) {
                await HttpService.UpdateExecutionUser(projectDetails._id, {
                    elUser: selectedElUser?._id ? { _id: selectedElUser._id, name: selectedElUser.name } : undefined,
                    pmUser: selectedPmUser?._id ? { _id: selectedPmUser._id, name: selectedPmUser.name } : undefined
                });
            }

            if (isCompleted) {
                if (projectDetails?.cityOPSManagerApproval === "Pending") {
                    return props.setSnackInfo(
                        "This request is awaiting review by the Senior OPS Manager.",
                        "warning"
                    );
                }
                // Send for City Manager Approval

                data.cityManagerApproval = "Pending";
                response = await HttpService.sendForCityManagerApproval(data);

                props.setSnackInfo(
                    "Sent to City Manager for Approval",
                    "success"
                );
            } else {
                response = await HttpService.updateStatusFromUnderExecutionTo(data);
                props.setSnackInfo("Status Updated", "success");
            }
            getProjectLogs();
            getcustomerDetails();
            setOpenUpdateModel(false);
            if (response) {
                setPics([""]);
                // Reset all the uploaded files states
                setCompletionCertificate('');
                setPhotoUrls([]);
                setVideoUrls([]);
                setWhatsappUrls([]);
                setUploadedFiles({
                    s3Location: '',
                    photos: [],
                    videos: [],
                    whatsappScreenshots: []
                });
                setFile(null);
                setExtractResponse(null);
            }
            setClicked(false);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error");
            setPics([""]);
        }
        props.setLoading(false);
    };

    const updateStatus = async () => {
        setOpenUpdateModel(true);
        setSelectedElUser('');
        setSelectedPmUser('');

        const { data } = await HttpService.getTeamsBasedOnTeamId(userDetails.teamId._id);

        setElUsersOptions(data?.elUsers ?? []);
        setPmUsersOptions(data?.projectManagers ?? []);
    };

    // Resets every piece of state used inside the "Update Execution Status"
    // modal back to its default value. Called on Cancel/Close so the modal
    // always opens fresh the next time updateStatus() is triggered, instead
    // of showing whatever was left over from the previous attempt.
    const resetUpdateModalState = () => {
        props.setLoading(false);
        setClicked(false);
        setExecutionStage("Update");
        setSelectedElUser('');
        setSelectedPmUser('');
        setExecutionCompletionRemarks('');
        setCompletionCertificate('');
        setPhotoUrls([]);
        setVideoUrls([]);
        setWhatsappUrls([]);
        setPhotoInputs([{ id: 0 }]);
        setVideoInputs([{ id: 0 }]);
        setWhatsappInputs([{ id: 0 }]);
        setUploadedFiles({
            s3Location: '',
            photos: [],
            videos: [],
            whatsappScreenshots: []
        });
        setPhotoUploadingIds({});
        setVideoUploadingIds({});
        setWhatsappUploadingIds({});
        setCertificateUploading(false);
        setCertificateOtpSending(false);
        setCertificateOtpSent(false);
        setCertificateOtpExpected('');
        setCertificateOtpValue('');
        setCertificateOtpVerified(false);
        setCertificateOtpError('');
        setFile(null);
        setExtractResponse(null);
    };

    const renderTickMark = () => {
        if (fileUploaded) {
            return <span>&#10003;</span>;
        }
        return null;
    };

    const [openPaymentUpdateModel, setOpenPaymentUpdateModel] = useState(false);
    const [sendPaymentUpdateData, setSendPaymentUpdateData] = useState({
        paymentAttachement: "",
        amount: "",
        note: ""
    });

    const updateCustomerPayment = () => {
        setOpenPaymentUpdateModel(true);
    }

    const updateCustomerPaymentAndSendToFinance = async () => {
        // console.log(sendPaymentUpdateData, "sendPaymentData")
        props.setLoading(true)
        sendPaymentUpdateData.leadId = projectId;
        sendPaymentUpdateData.customerEmail = projectDetails.customerId?.email;
        sendPaymentUpdateData.customerName = projectDetails.customerId?.name;
        try {
            const response = await HttpService.updateCustomerPaymentAndSendToFinance(projectId, sendPaymentUpdateData)
            // console.log(response.data, "Response data")
            setIsFinalPaymentReceived(false);
            setOpenPaymentUpdateModel(false);
            props.setSnackInfo("Payment Updated successfully", "success")
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [moveDealOpen, setMoveDealOpen] = useState(false);
    const moveDeal = () => {
        setMoveDealOpen(true)
        getDepartments();
    }

    const [allUsersList, setAllUsersList] = useState([]);
    const getAllUsers = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getAllUsers()
            let userData = [];
            response.data.forEach((ele) => {
                userData.push({
                    name: ele.name,
                    userId: ele._id
                })
            })
            setAllUsersList(userData)

        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const [mentionOpen, setMentionOpen] = useState(false);
    const [suggestions, setSuggestions] = useState(allUsersList);

    const { MentionSuggestions, plugins } = useMemo(() => {
        const mentionPlugin = createMentionPlugin();
        const { MentionSuggestions } = mentionPlugin;
        const plugins = [mentionPlugin];
        return { plugins, MentionSuggestions };
    }, []);

    const setEditorStateData = (editorState) => {
        setEditorState(editorState);
        setFormData({ ...formData, 'notes': editorRef.current?.editor?.editor?.innerText })
    };

    const onOpenChange = (mentionOpen) => {
        if (mentionOpen === false) {
            setMentionOpen(false)
        } else {
            setMentionOpen(true)
        }
    };

    const onSearchChange = ({ value }) => {
        setSuggestions(defaultSuggestionsFilter(value, allUsersList));
    };

    const onAddMention = (mention) => {
        setMentionOpen(false)
    }

    const [openStatusModal, setOpenStatusModal] = useState(false);
    const openStatusUpdateModal = () => {
        setOpenStatusModal(true);
    }

    const saveNotes = async () => {
        const contentState = editorState.getCurrentContent();
        const raw = convertToRaw(contentState);
        let mentionedUsers = [];
        for (let key in raw.entityMap) {
            const ent = raw.entityMap[key];
            if (ent.type === "mention") {
                mentionedUsers.push(ent.data.mention);
            }
        }
        let taggedUser = [];
        mentionedUsers.forEach((ele, i) => {
            taggedUser.push(ele.userId);
        })

        let obj = {
            ...formData,
            taggedUser: taggedUser,
            'innerHTML': editorRef.current?.editor?.editor?.innerHTML,
            reminderData: {
                isReminderClose: false,  // Default value
                reminderCreatedBy: userDetails._id,
                reminderTaggedUser: taggedUser,
                lastReminderCreatedDate: new Date(),
                reminderDate: formData.reminderDate // current Date value
            }
        }
        obj.sendNoteToClient = sendNoteToClient
        props.setLoading(true);
        try {
            const addNoteResponse = await HttpService.addNotes(obj);
            if (addNoteResponse.status === 200) {
                setOpenNotesModal(false);
                getProjectLogs();
                getcustomerDetails();
                setFormData({
                    notes: "",
                    reminderDate: "",
                    s3Location: "",
                    leadId: "",
                    user: "",
                    stage: ""
                })
                setEditorState(() => EditorState.createEmpty());
                setFileUploaded(false);
                props.setSnackInfo("Notes Added Successfully", "success")
            }
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    }

    const [executionCompletionRemarks, setExecutionCompletionRemarks] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState({
        s3Location: '',
        photos: [],
        videos: [],
        whatsappScreenshots: []
    });

    // State for tracking uploaded files
    const [completionCertificate, setCompletionCertificate] = useState('');
    const [photoUrls, setPhotoUrls] = useState([]);
    const [videoUrls, setVideoUrls] = useState([]);
    const [whatsappUrls, setWhatsappUrls] = useState([]);

    // State for managing file inputs
    const [photoInputs, setPhotoInputs] = useState([{ id: 0 }]);
    const [videoInputs, setVideoInputs] = useState([{ id: 0 }]);
    const [whatsappInputs, setWhatsappInputs] = useState([{ id: 0 }]);

    // Per-row inline loaders for photo/video/whatsapp uploads, keyed by the
    // input's stable id (not its array index, since index shifts when a row
    // is removed) - lets each upload row show its own "Uploading..." state
    // instead of blocking the whole page via props.setLoading.
    const [photoUploadingIds, setPhotoUploadingIds] = useState({});
    const [videoUploadingIds, setVideoUploadingIds] = useState({});
    const [whatsappUploadingIds, setWhatsappUploadingIds] = useState({});

    // Inline loader for the completion certificate upload (scoped to this
    // action only, instead of blocking the whole page via props.setLoading)
    const [certificateUploading, setCertificateUploading] = useState(false);

    // Customer OTP verification, required before the completion status can
    // be moved forward - only mandatory for Bangalore leads
    const [certificateOtpSending, setCertificateOtpSending] = useState(false);
    const [certificateOtpSent, setCertificateOtpSent] = useState(false);
    const [certificateOtpExpected, setCertificateOtpExpected] = useState('');
    const [certificateOtpValue, setCertificateOtpValue] = useState('');
    const [certificateOtpVerified, setCertificateOtpVerified] = useState(false);
    const [certificateOtpError, setCertificateOtpError] = useState('');
    // const isBangaloreLead = projectDetails?.experienceCenterId?.locationId?.name === 'Bangalore';

    // Upload completion certificate
    const uploadCompletionCertificate = async (e) => {
        setCertificateUploading(true);
        const fd = new FormData();
        const extensionName = e.target.files[0].name.split('.').pop();
        fd.append('file', e.target.files[0], `${projectDetails.erpProjectNo}_Completion Certificate.${extensionName}`);
        fd.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name);

        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            setUploadedFiles({
                ...uploadedFiles,
                s3Location: fileUploadRes.data
            });
            setCompletionCertificate(fileUploadRes.data);
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        }
        setCertificateUploading(false);
    };

    // Send a customer OTP to the customer's registered email only, via the
    // dedicated handover-completion OTP endpoint (backend: user.js
    // /sendHandoverCompletionOtp). Unlike the generic
    // sendOtpAccordingToContactTypeEmailOrMobile route, this one sends a
    // confidential, purpose-built email that names the Decorpot employee
    // (the logged-in user) the customer should share the OTP with.
    const sendCertificateOtp = async () => {
        const customerEmail = projectDetails?.customerId?.email;
        if (!customerEmail) {
            props.setSnackInfo("Customer email not found on this lead", "error");
            return;
        }
        setCertificateOtpSending(true);
        setCertificateOtpError('');
        try {
            const response = await HttpService.sendHandoverCompletionOtp({
                email: customerEmail,
                customerName: projectDetails?.customerId?.name,
                employeeName: userDetails?.name,
                stage: executionStage.status,
                certificateUrl: completionCertificate,
                leadId: projectId
            });
            const bytes = CryptoJs.AES.decrypt(response.data.otp, 'decorpot123');
            // const bytes = CryptoJs.AES.decrypt(response.data.otp, 'DECORPOTPHONEENCRYPTIONKEY2024XYZ');
            setCertificateOtpExpected(bytes.toString(CryptoJs.enc.Utf8));
            setCertificateOtpSent(true);
            setCertificateOtpVerified(false);
            setCertificateOtpValue('');
            props.setSnackInfo("OTP sent to customer's email and WhatsApp", "success");
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.msg ?? "Failed to send OTP", "error");
        }
        setCertificateOtpSending(false);
    };

    const verifyCertificateOtp = (value) => {
        const digitsOnly = value.replace(/[^0-9]/g, "").slice(0, 6);
        setCertificateOtpValue(digitsOnly);
        if (digitsOnly.length !== 6) {
            setCertificateOtpVerified(false);
            setCertificateOtpError('');
            return;
        }
        if (digitsOnly === certificateOtpExpected) {
            setCertificateOtpVerified(true);
            setCertificateOtpError('');
        } else {
            setCertificateOtpVerified(false);
            setCertificateOtpError('Incorrect OTP. Please try again.');
        }
    };

    // Customer OTP card shown below the completion-certificate upload button.
    // The customer must verify an OTP before the status can be moved forward.
    const renderCertificateOtpSection = () => (
        <Card className={classes.otpCard} variant="outlined">
            <div className={classes.otpCardHeader}>
                <LockIcon fontSize="small" />
                <Typography style={{ fontWeight: 700, fontSize: 15 }}>
                    Customer Verification
                </Typography>
            </div>

            {certificateOtpVerified ? (
                <div className={classes.otpVerifiedBanner}>
                    <VerifiedUserIcon />
                    <Typography variant="body2" style={{ fontWeight: 600 }}>
                        Verified by customer via OTP - ready to move forward.
                    </Typography>
                </div>
            ) : (
                <CardContent className={classes.otpCardBody}>
                    <Typography variant="body2" style={{ color: "#555", marginBottom: 12 }}>
                        An OTP must be verified with the customer{projectDetails?.customerId?.email ? ` (${projectDetails.customerId.email})` : ''} over email or WhatsApp before this can move forward.
                    </Typography>

                    {!certificateOtpSent ? (
                        <Button
                            className={classes.otpSendButton}
                            variant="contained"
                            startIcon={certificateOtpSending ? <CircularProgress size={16} style={{ color: "#fff" }} /> : <MailOutlineIcon />}
                            onClick={sendCertificateOtp}
                            disabled={certificateOtpSending}
                        >
                            {certificateOtpSending ? "Sending OTP..." : "Send OTP to Customer"}
                        </Button>
                    ) : (
                        <>
                            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    placeholder="• • • • • •"
                                    value={certificateOtpValue}
                                    onChange={(e) => verifyCertificateOtp(e.target.value)}
                                    inputProps={{ maxLength: 6, className: classes.otpInputBox }}
                                    style={{ width: 160 }}
                                    error={Boolean(certificateOtpError)}
                                />
                                <Button
                                    className={classes.otpVerifyButton}
                                    variant="outlined"
                                    startIcon={
                                        certificateOtpSending
                                            ? <CircularProgress size={14} style={{ color: "#F47E44" }} />
                                            : <AutorenewIcon />
                                    }
                                    onClick={sendCertificateOtp}
                                    disabled={certificateOtpSending}
                                >
                                    {certificateOtpSending ? "Resending..." : "Resend"}
                                </Button>
                            </div>
                            {certificateOtpError && (
                                <Typography variant="caption" style={{ color: "#c62828", display: "block", marginTop: 8 }}>
                                    {certificateOtpError}
                                </Typography>
                            )}
                            {certificateOtpSending ? (
                                <Typography variant="caption" style={{ color: "#F47E44", fontWeight: 600, display: "block", marginTop: 8 }}>
                                    Sending a new OTP to the customer - this can take a few seconds...
                                </Typography>
                            ) : (
                                <Typography variant="caption" style={{ color: "#888", display: "block", marginTop: 8 }}>
                                    OTP sent via email and WhatsApp. Ask the customer for the 6-digit code to confirm.
                                </Typography>
                            )}
                        </>
                    )}
                </CardContent>
            )}
        </Card>
    );

    // Upload photos - shows its own inline loader on the row being uploaded
    // (keyed by the row's stable input id) instead of the full-page loader.
    const uploadPhoto = async (e, index, inputId) => {
        setPhotoUploadingIds(prev => ({ ...prev, [inputId]: true }));
        const fd = new FormData();
        const extensionName = e.target.files[0].name.split('.').pop();
        fd.append('file', e.target.files[0], `${projectDetails.erpProjectNo}_Photo_${index}.${extensionName}`);
        fd.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name);

        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            const newPhotoUrls = [...photoUrls];
            newPhotoUrls[index] = fileUploadRes.data;
            setPhotoUrls(newPhotoUrls);

            setUploadedFiles({
                ...uploadedFiles,
                photos: [...uploadedFiles.photos, fileUploadRes.data]
            });
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        }
        setPhotoUploadingIds(prev => ({ ...prev, [inputId]: false }));
    };

    // Upload videos - same per-row inline loader pattern as uploadPhoto.
    const uploadVideo = async (e, index, inputId) => {
        setVideoUploadingIds(prev => ({ ...prev, [inputId]: true }));
        const fd = new FormData();
        const extensionName = e.target.files[0].name.split('.').pop();
        fd.append('file', e.target.files[0], `${projectDetails.erpProjectNo}_Video_${index}.${extensionName}`);
        fd.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name);

        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            const newVideoUrls = [...videoUrls];
            newVideoUrls[index] = fileUploadRes.data;
            setVideoUrls(newVideoUrls);

            setUploadedFiles({
                ...uploadedFiles,
                videos: [...uploadedFiles.videos, fileUploadRes.data]
            });
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        }
        setVideoUploadingIds(prev => ({ ...prev, [inputId]: false }));
    };

    // Upload WhatsApp screenshots - same per-row inline loader pattern.
    const uploadWhatsappScreenshot = async (e, index, inputId) => {
        setWhatsappUploadingIds(prev => ({ ...prev, [inputId]: true }));
        const fd = new FormData();
        const extensionName = e.target.files[0].name.split('.').pop();
        fd.append('file', e.target.files[0], `${projectDetails.erpProjectNo}_WhatsApp_${index}.${extensionName}`);
        fd.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name);

        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            const newWhatsappUrls = [...whatsappUrls];
            newWhatsappUrls[index] = fileUploadRes.data;
            setWhatsappUrls(newWhatsappUrls);

            setUploadedFiles({
                ...uploadedFiles,
                whatsappScreenshots: [...uploadedFiles.whatsappScreenshots, fileUploadRes.data]
            });
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        }
        setWhatsappUploadingIds(prev => ({ ...prev, [inputId]: false }));
    };

    // Handlers for adding/removing input fields
    const handleAddPhotoInput = () => {
        const newId = photoInputs.length > 0 ? Math.max(...photoInputs.map(input => input.id)) + 1 : 0;
        setPhotoInputs([...photoInputs, { id: newId }]);
    };

    const handleRemovePhotoInput = (idToRemove) => {
        setPhotoInputs(photoInputs.filter(input => input.id !== idToRemove));

        // Remove the URL from the state as well
        const index = photoInputs.findIndex(input => input.id === idToRemove);
        if (index !== -1) {
            const newPhotoUrls = [...photoUrls];
            newPhotoUrls.splice(index, 1);
            setPhotoUrls(newPhotoUrls);

            setUploadedFiles({
                ...uploadedFiles,
                photos: newPhotoUrls
            });
        }
    };

    const handleAddVideoInput = () => {
        const newId = videoInputs.length > 0 ? Math.max(...videoInputs.map(input => input.id)) + 1 : 0;
        setVideoInputs([...videoInputs, { id: newId }]);
    };

    const handleRemoveVideoInput = (idToRemove) => {
        setVideoInputs(videoInputs.filter(input => input.id !== idToRemove));

        // Remove the URL from the state as well
        const index = videoInputs.findIndex(input => input.id === idToRemove);
        if (index !== -1) {
            const newVideoUrls = [...videoUrls];
            newVideoUrls.splice(index, 1);
            setVideoUrls(newVideoUrls);

            setUploadedFiles({
                ...uploadedFiles,
                videos: newVideoUrls
            });
        }
    };

    const handleAddWhatsappInput = () => {
        const newId = whatsappInputs.length > 0 ? Math.max(...whatsappInputs.map(input => input.id)) + 1 : 0;
        setWhatsappInputs([...whatsappInputs, { id: newId }]);
    };

    const handleRemoveWhatsappInput = (idToRemove) => {
        setWhatsappInputs(whatsappInputs.filter(input => input.id !== idToRemove));

        // Remove the URL from the state as well
        const index = whatsappInputs.findIndex(input => input.id === idToRemove);
        if (index !== -1) {
            const newWhatsappUrls = [...whatsappUrls];
            newWhatsappUrls.splice(index, 1);
            setWhatsappUrls(newWhatsappUrls);

            setUploadedFiles({
                ...uploadedFiles,
                whatsappScreenshots: newWhatsappUrls
            });
        }
    };

    const uploadCreateNoteImg = async (e) => {
        props.setLoading(true)
        const fd = new FormData()
        const extensionName = e.target.files[0].name.split('.').pop()
        fd.append('file', e.target.files[0], `${projectDetails.erpProjectNo}_Completion Certificate.${extensionName}`)
        fd.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name)
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            setFormData({
                ...formData,
                s3Location: fileUploadRes.data
            })
            setFileUploaded(true);
            setCompletetionCertificate(formData)
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    const [stageIndex, setStageIndex] = useState(0);
    const [openNotesInfoModal, setOpenNotesInfoModal] = useState(false);
    const [stageInfo, setStageInfo] = useState("");
    const [openActivity, setOpenActivity] = useState('')
    const showInfo = (i, status) => {
        setStageIndex(i);
        setOpenNotesInfoModal(true);
        setStageInfo(projectLogs[i]['stage'])
        setOpenActivity(status)
    }

    const downloadNotesFile = (data) => {
        // Create a temporary anchor element
        const link = document.createElement('a');
        // Set the href to the file URL
        link.href = data;
        // Extract filename from URL
        const filename = data.substring(data.lastIndexOf('/') + 1);
        // Set download attribute with the filename
        link.setAttribute('download', filename);
        // Hide the element (optional)
        link.style.display = 'none';
        // Append to the document
        document.body.appendChild(link);
        // Trigger click programmatically
        link.click();
        // Clean up - remove the element after use
        setTimeout(() => {
            document.body.removeChild(link);
        }, 100);
    };

    const openAnotherDialog = () => {
        setMoveDealOpen(false);
        setOpenMoveDealDetailsDialog(true);
        getDepartments();
    }
    const handleSelectedDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
        getTeamsList(event.target.value)
    }
    const handleSelectedTeamChange = (event) => {
        setSelectedTeam(event.target.value);
        getUserList(event.target.value)
    }
    const handleSelectedUserChange = (event) => {
        setSelectedDealOwner(event.target.value);
    }
    const getDepartments = async () => {
        try {
            const department = await HttpService.getDepartments();
            if (userDetails?.roles?.find(role => role.name !== 'Admin')) {
                if (userDetails?.roles?.find(role => role.name === ROLENAME.MarketingUser || role.name === ROLENAME.MarketingManager)) {
                    setDepartmentsList(department.data.filter(ele => ele.name === 'Sales'));
                } else {
                    setDepartmentsList(department.data.filter(ele => ele._id === userDetails.departmentId))
                }
            }
            getDepartmentStages(department.data);
        } catch (error) {
            console.log(error, "get department error")
        }
    }

    const getTeamsList = async (deptid) => {
        let teams = [];
        teams = departmentLists.filter(ele => ele._id === deptid)
        const centerTeams = [];
        teams[0]['teams'].forEach(ele => {
            ele.experienceCenterId.forEach(centerId => {
                if (centerId === userDetails.selectedExpCenter) {
                    centerTeams.push(ele)
                }
            })
        })
        const activeTeamList = centerTeams.filter(ele => ele.isActive === true)
        setTeamList(activeTeamList)
    }

    const getUserList = async (teamid) => {
        if (userDetails?.roles?.find(role => ROLENAME.MarketingUser || role.name === ROLENAME.MarketingManager)) {
            try {
                const users = await HttpService.getQTTeamUsers(teamid);
                let activeUsers = users.data.users.filter(ele => ele.isActive === true)
                setDealOwnersList(activeUsers)
            } catch (error) {
                console.log(error, "Error");
            }
        } else if (teamid === userDetails.teamId._id) {
            try {
                const users = await HttpService.getQTTeamUsers(teamid);
                let activeUsers = users.data.users.filter(ele => ele.isActive === true)
                setDealOwnersList(activeUsers)
            } catch (error) {
                console.log(error, "Error");
            }
        } else {
            try {
                const teamUsers = await HttpService.getQtTeamManager(teamid);
                let teamManager = [];
                let obj = {
                    _id: teamUsers.data.manager._id,
                    name: teamUsers.data.manager.name
                }
                teamManager.push(obj);
                setDealOwnersList(teamManager)
            } catch (error) {
                console.log(error, "Error");
            }
        }
    }

    const getDepartmentStages = async (data) => {
        let stages = []
        console.log(data, "data")
        if (userDetails.roles.find(role => role.name === ROLENAME.IMOSManager || role.name === ROLENAME.IMOSUser)) {
            data.forEach((element) => {
                if (element['name'] === 'IMOS') {
                    stages.push(element['stages']);
                };
            });
        }
        setDepartmentsStage(stages[0]);
    }

    const handleSelectedStageChange = (event) => {
        setSelectedStage(event.target.value);
    }
    const handleExecutionStageChange = (event) => {
        setExecutionStage(event.target.value);
    }


    const assignLeadToUser = async () => {
        let dealData = {
            stage: selectedStage,
            department: department,
            team: team,
            id: dealOwner,
            leadId: projectId
        };
        if (userDetails.departmentId === constantDepartmentId.imos) {
            dealData.stageDepartment = 'imos'
        }
        try {
            props.setLoading(true)
            const assignProject = await HttpService.assignProject(dealData);
            if (assignProject.status === 200) {
                setOpenMoveDealDetailsDialog(false);
                setSelectedStage('');
                setSelectedDepartment('');
                setSelectedTeam('');
                setSelectedDealOwner('');
                getProjectLogs();
                getcustomerDetails();
                props.setSnackInfo("Project assigned Successful", "success")
            }
        } catch (error) {
            console.log(error, "assign project error");
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const [openStageStatusModal, setOpenStageStatusModal] = useState(false)
    const [sendNoteToClient, setSendNoteToClient] = useState(true);
    const openUpdateStageModal = () => {
        setOpenStageStatusModal(true);
    }
    const [selectedStageStatus, setSelectedStageStatus] = useState('')
    const [dispatchDate, setDispatchDate] = useState(moment().toISOString(new Date()));
    const handleSelectedStageStatus = (event) => {
        setSelectedStageStatus(event.target.value)
    }

    const updateStageStatus = async () => {
        if (selectedStageStatus === 'Ready for dispatch') {
            // Send mail to priyanka with dispatch date
            let obj = {
                readyToDispatchDate: dispatchDate,
                factoryStage: selectedStageStatus
            }
            try {
                props.setLoading(true)
                const assignProject = await HttpService.updateToReadyToDispatch(projectId, obj);
                if (assignProject.status === 200) {
                    setOpenStageStatusModal(false);
                    getProjectLogs();
                    getcustomerDetails();
                    props.setSnackInfo("Project assinged to CRM Successful", "success")
                }
            } catch (error) {
                console.log(error, "assign project error");
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false)
        } else {
            let obj = {
                factoryStage: selectedStageStatus
            }
            try {
                props.setLoading(true)
                const assignProject = await HttpService.updateFactoryStage(projectId, obj);
                if (assignProject.status === 200) {
                    setOpenStageStatusModal(false);
                    getProjectLogs();
                    getcustomerDetails();
                    props.setSnackInfo("Project Factory Stage Successful", "success")
                }
            } catch (error) {
                console.log(error, "stage update error");
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false)
        }
    }

    const [openUpdateMaterialStatusModal, setOpenUpdateMaterialStatusModal] = useState(false);
    const [selectedMaterilPercentage, setSelectedMaterilPercentage] = useState('');
    const updateMaterialReceived = async () => {
        let obj = {}
        if (selectedMaterilPercentage === 'Yes') {
            obj = { materialReceived: true }
        } else {
            obj = { materialReceived: false }
        }
        try {
            props.setLoading(true)
            const assignProject = await HttpService.uploadUpdatedFileAndData(projectId, obj);
            if (assignProject.status === 200) {
                setOpenUpdateMaterialStatusModal(false);
                getProjectLogs();
                getcustomerDetails();
                props.setSnackInfo("Project Factory Stage Successful", "success")
            }
        } catch (error) {
            console.log(error, "stage update error");
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const [isFinalPaymentReceived, setIsFinalPaymentReceived] = useState(false);
    const uploadWDFileDocument = async (e) => {
        try {
            props.setLoading(true)
            const formData = new FormData()
            formData.append('file', e.target.files[0])
            formData.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name)
            const result = await HttpService.wdFileUpload(formData);
            setSendPaymentUpdateData({ ...sendPaymentUpdateData, paymentAttachement: result.data })
            setIsFinalPaymentReceived(true);
            props.setSnackInfo("Design Sign-off File Upload Success", "success")
        } catch (error) {
            console.log(error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const updateAssignUser = async () => {
        setUserModel(true);

        const { data } = await HttpService.getTeamsBasedOnTeamId(userDetails.teamId._id);

        setUsersData(data?.elUsers ?? []);
    };

    const updateAssignPMUser = async () => {
        setUserModel(true);

        const { data } = await HttpService.getTeamsBasedOnTeamId(userDetails.teamId._id);

        setUsersData(data?.projectManagers ?? []);
    };
    const handleSelectedUsersChange = (event) => {
        setSelectedUser(event.target.value);
    }
    const updateToNewUser = async () => {
        let obj = {}
        obj._id = selectedUser._id
        obj.name = selectedUser.name
        try {
            props.setLoading(true)
            const result = await HttpService.UpdateExecutionUser(projectDetails._id, obj);
            props.setSnackInfo("Successfully Updated", "success")
            setUserModel(false)
        } catch (error) {
            console.log(error, "stage update error");
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const handleSelectedElUserChange = (event) => {
        setSelectedElUser(event.target.value);
    }
    const handleSelectedPmUserChange = (event) => {
        setSelectedPmUser(event.target.value);
    }
    const onImageChange = async (event, index) => {
        try {
            const newFiles = [...pics];

            props.setLoading(true);
            const fd = new FormData();
            fd.append("file", event.target.files[0]);
            fd.append('customerName', projectDetails.lead_no);
            const fileUploadRes = await HttpService.uploadFile(fd);
            newFiles[index] = fileUploadRes.data;
            setPics(newFiles)

            props.setSnackInfo("Photo Upload Success", "success");
        } catch (err) {
            console.log('photos upload error', err)
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
            props.setLoading(false);
        }
    };

    const handleAddFilesInput = () => {
        let newFiles = [...pics];
        newFiles.push("");
        setPics(newFiles); // site photos //done
    };
    const handleRemoveFilesInput = (index) => {
        const newFiles = [...pics];
        newFiles.splice(index, 1);
        setPics(newFiles);
    }

    const handleViewClick = (input) => {
        if (input.user.name && input.user.mobile && input.user.email) {
            setSelectedLeadLogViewDetails(
                {
                    ...selectedLeadLogViewDetails,
                    noteUserName: input.user.name,
                    noteUserContact: input.user.mobile,
                    noteUserEmail: input.user.email,
                    note: input.notes,
                    attachment: input.s3Location[0] || 'NA',
                    assistantManagerName: input.user?.assistantManagerId?.name || 'NA',
                    assistantManagerMobile: input.user?.assistantManagerId?.mobile || 'NA',
                    assistantManagerEmail: input.user?.assistantManagerId?.email || 'NA'
                }
            )
        }
        setOpenWhatsAppNotificationContentDialog(true)
        setWhatsAppNotificationContent(input.whatsAppTemplateId.template_content)
    }

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        if (!selectedFile) return;

        if (selectedFile.type !== "application/pdf") {
            props.setSnackInfo("Please upload PDF only", "error");
            return;
        }
        setFile(selectedFile);
        setExtractResponse(null);
    };

    const handleExtract = async () => {
        if (!file) {
            props.setSnackInfo("Please upload a PDF first", "error");
            return;
        }

        try {
            // setLoading(true);
            // Clear previous result immediately
            setExtractResponse(null);

            const formData = new FormData();
            const extensionName = file.name.split('.').pop();
            formData.append('file', file, `${projectDetails.erpProjectNo}_Completion Certificate.${extensionName}`);
            formData.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name);

            const s3Res = await HttpService.uploadFile(formData);
            const s3Url = s3Res?.data?.url || s3Res?.data;

            // const response =
            //     await HttpService.extractCompletionCertificate({
            //         pdfURL: s3Url,
            //         leadId: projectId
            //     });

            setCompletionCertificate(s3Url);
            // setExtractResponse(response.data);

        } catch (err) {
            console.log("Status:", err?.response?.status);
            console.log("Response:", err?.response?.data);
            if (err?.response?.status === 422) {
                setExtractResponse(err.response.data);
                props.setSnackInfo(
                    "Document validation failed. Please review the issues below.",
                    "error"
                );
                return;
            }
            props.setSnackInfo(
                "Error occurred while extracting data",
                "error"
            );
        } finally {
            // setLoading(false);
        }
    };


    const isCompleted =
        executionStage.status === "Completed" ||
        executionStage.status === "Completed-MWP";

    return (
        <div>
            <div className={classes.root}>
                <Grid container spacing={3}>
                    {/* Details */}
                    <Grid item lg={6} md={6} sm={12}>
                        <Paper className={classes.paper}>

                            {/* Customer Details */}
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className={classes.heading}>Customer Details</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails style={{ padding: '8px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                                <TableRow key='1'>
                                                    <TableCell>Customer Name</TableCell>
                                                    <TableCell>{maskedCustomerName}</TableCell>
                                                </TableRow>
                                                <TableRow key='2'>
                                                    <TableCell>Contact</TableCell>
                                                    <TableCell>{projectDetails?.customerId?.contact_no}</TableCell>
                                                </TableRow>
                                                <TableRow key='3'>
                                                    <TableCell>Email</TableCell>
                                                    <TableCell>{maskedCustomerEmail}</TableCell>
                                                </TableRow>
                                                <TableRow key='4'>
                                                    <TableCell>Address</TableCell>
                                                    <TableCell>{projectDetails?.customerId?.address}</TableCell>
                                                </TableRow>
                                                <TableRow key='5'>
                                                    <TableCell>Current Stage</TableCell>
                                                    <TableCell>
                                                        {projectDetails.currentStage}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='6'>
                                                    <TableCell>Assigned To</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.assignTo?.name}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='7'>
                                                    <TableCell>Lead Number</TableCell>
                                                    <TableCell>{projectDetails?.lead_no}</TableCell>
                                                </TableRow>
                                                <TableRow key='8'>
                                                    <TableCell>Project No.</TableCell>
                                                    <TableCell>{projectDetails?.erpProjectNo ? projectDetails?.erpProjectNo : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow key='9'>
                                                    <TableCell>ExperienceCenter</TableCell>
                                                    <TableCell>{projectDetails?.experienceCenterId?.name ? projectDetails?.experienceCenterId?.name : '-'}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>

                                <Divider />

                                <AccordionActions>
                                    <Button variant="contained" color="primary" size="small" onClick={() => viewCheckList()}>View Check List</Button>
                                    {/* <Button variant="contained" color="primary" size="small" onClick={sendMailToCustomer} disabled={projectDetails?.finalPaymentApprovalRequestStatus === 'Sent' || projectDetails?.finalPaymentApprovalRequestStatus === 'Approved'} >Send Mail to Customer</Button> */}
                                    {/* <Button variant="contained" color="primary" size="small" onClick={updateCustomerPayment} disabled={projectDetails?.finalPaymentApprovalRequestStatus === 'Sent' || projectDetails?.finalPaymentApprovalRequestStatus === 'Approved'} >Update Payment</Button> */}
                                    <Button variant="contained" color="primary" size="small" onClick={openCreateNotesModal}>Add Notes</Button>
                                    {/* <Button variant="contained" color="primary" size="small" onClick={updateStatus} disabled={projectDetails?.finalPaymentApprovalRequestStatus === 'Sent' || projectDetails?.finalPaymentApprovalRequestStatus === 'Approved'} >Update Status</Button> */}
                                    <Button variant="contained" color="primary" size="small" onClick={updateStatus} disabled={projectDetails?.finalPaymentApprovalRequestStatus === 'Sent' || projectDetails?.finalPaymentApprovalRequestStatus === 'Approved' || projectDetails?.currentStage === 'Completed'} >Update Status</Button>
                                    {userDetails?.roles?.find(role => role.name === ROLENAME.SeniorOperationManager) ? (
                                        <Button variant="contained" color="primary" size="small" onClick={updateAssignUser}>Assign To EL User</Button>
                                    ) : (
                                        <Button variant="contained" color="primary" size="small" onClick={updateAssignPMUser}>Assign To PM</Button>
                                    )}
                                </AccordionActions>
                            </Accordion>

                            {/* Design Details  */}
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={classes.heading}>Design Details</Typography>
                                </AccordionSummary>
                                <Divider />

                                <AccordionDetails style={{ padding: '35px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                                <TableRow key='3'>
                                                    <TableCell>Internal Design Sign-off Date</TableCell>
                                                    <TableCell>{projectDetails?.internalDesignSignOffDate ? moment(projectDetails?.internalDesignSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                {/* <TableRow key='1'>
                                                    <TableCell>Expected Design Sign-off Date</TableCell>
                                                    <TableCell>{projectDetails?.expectedDesignSignOffDate ? moment(projectDetails?.expectedDesignSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow> */}
                                                <TableRow key='2'>
                                                    <TableCell>Days from Contract sign:</TableCell>
                                                    <TableCell>{daysfromContractsign !== "" ? daysfromContractsign.toFixed(0) : `-`}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>

                            </Accordion>

                            {/* Deals Details */}
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={classes.heading}>Post design Sign-off Details Details</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails style={{ padding: '8px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                                <TableRow key='0a'>
                                                    <TableCell>Execution Lead</TableCell>
                                                    <TableCell>{projectDetails?.executionLead?.name ? projectDetails?.executionLead?.name : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow key='0b'>
                                                    <TableCell>Project Manager</TableCell>
                                                    <TableCell>{projectDetails?.projectManager?.name ? projectDetails?.projectManager?.name : '-'}</TableCell>
                                                </TableRow>
                                                <TableRow key='1'>
                                                    <TableCell>Design Sign-off Date</TableCell>
                                                    {/* <TableCell>{projectDetails?.designSignOffDate ? moment(projectDetails?.designSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell> */}
                                                    <TableCell>{projectDetails?.customerDesignSignOffDate ? moment(projectDetails?.customerDesignSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='2'>
                                                    <TableCell>Expected Project Completion Date</TableCell>
                                                    <TableCell>{projectDetails?.projectCompletionDate ? moment(projectDetails?.projectCompletionDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='2b'>
                                                    <TableCell>Actual Project Completion Date</TableCell>
                                                    <TableCell>{projectDetails?.executionCompletionDate ? moment(projectDetails?.executionCompletionDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='2c'>
                                                    <TableCell>Factory Ready to Dispatch Date</TableCell>
                                                    <TableCell>{projectDetails?.readyToDispatchDate ? moment(projectDetails?.readyToDispatchDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='2a'>
                                                    <TableCell>Material Dispatched Date</TableCell>
                                                    <TableCell>{projectDetails?.materialDispatchedDate ? moment(projectDetails?.materialDispatchedDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='2b'>
                                                    <TableCell>Material Delivery Date</TableCell>
                                                    <TableCell>{projectDetails?.materialDeliveryDate ? moment(projectDetails?.materialDeliveryDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                {/* <TableRow key='3'>
                                                    <TableCell>Modular Delivery Date</TableCell>
                                                    <TableCell>{projectDetails?.modularDeliveryDate ? moment(projectDetails?.modularDeliveryDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow> */}
                                                <TableRow key='4'>
                                                    <TableCell>Signed Quotation File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanQuotationFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.scanQuotationFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='19'>
                                                    <TableCell>Project Kick-Off Check List File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanProjectKickOffCheckListFile ?
                                                            <span onClick={() => window.open(projectDetails?.scanProjectKickOffCheckListFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='20'>
                                                    <TableCell>SiteQC Check List File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanSiteQCCheckListFile ?
                                                            <span onClick={() => window.open(projectDetails?.scanSiteQCCheckListFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='21'>
                                                    <TableCell>SiteQC Photos</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanSiteQCPhotos && projectDetails.scanSiteQCPhotos.length > 0 ? (
                                                            projectDetails.scanSiteQCPhotos.map((photo, index) => (
                                                                <span key={index} onClick={() => window.open(photo)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            ))
                                                        ) : (
                                                            `-`
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='5'>
                                                    <TableCell>Signed Check List</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanCheckListFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.scanCheckListFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='6'>
                                                    <TableCell>Working Drawing File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.workingDrawingFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.workingDrawingFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='7'>
                                                    <TableCell>Contract Sign File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.customerAgreementPdf ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.customerAgreementPdf)} > <GetAppOutlinedIcon /> </span>
                                                            : projectDetails?.termsAndConditionsPdf ?
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.termsAndConditionsPdf)} > <GetAppOutlinedIcon /> </span>
                                                                :
                                                                `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='8a'>
                                                    <TableCell>Quotation File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanQuotationFile ?
                                                            <span onClick={() => window.open(projectDetails?.scanQuotationFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='8b'>
                                                    <TableCell>Quotation Csv File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.quotationCsvFile ?
                                                            <span onClick={() => window.open(projectDetails?.quotationCsvFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='1i'>
                                                    <TableCell>Final Working Drawing by Site QC</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.finalWDFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.finalWDFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='8'>
                                                    <TableCell>Carpentry File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosCarpentryFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosCarpentryFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosCarpentryFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosCarpentryFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='9'>
                                                    <TableCell>Custom File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosCustomFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosCustomFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosCustomFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosCustomFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='10'>
                                                    <TableCell>Edge Band File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosEdgeBandingFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosEdgeBandingFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosEdgeBandingFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosEdgeBandingFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='11'>
                                                    <TableCell>Hardware File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosHardwareFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosHardwareFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosHardwareFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosHardwareFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='12'>
                                                    <TableCell>Pasting PDF File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosPastingListPdf ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosPastingListPdf)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosPastingListPdf ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosPastingListPdf)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='13'>
                                                    <TableCell>Pasting Excel File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosPastingListExcel ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosPastingListExcel)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosPastingListExcel ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosPastingListExcel)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='14'>
                                                    <TableCell>Saw File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosSawFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosSawFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosSawFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosSawFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='15'>
                                                    <TableCell>MPR File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosMprFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosMprFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosMprFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosMprFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='16'>
                                                    <TableCell>Tracking File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosTrackingFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosTrackingFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosTrackingFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosTrackingFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='17'>
                                                    <TableCell>Updated Pasting List File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.updatedPastingListFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.updatedPastingListFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='18'>
                                                    <TableCell>Jali File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.imosJaliFile ?
                                                            <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosJaliFile)} > <GetAppOutlinedIcon /> </span>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {projectDetails?.newImosJaliFile ?
                                                            <Tooltip title="New File">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosJaliFile)} > <GetAppOutlinedIcon /> </span>
                                                            </Tooltip>
                                                            : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='18a'>
                                                    <TableCell>Execution Completion Videos</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.videoUrls && projectDetails.videoUrls.length > 0 ? (
                                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                                {projectDetails.videoUrls.map((url, index) => (
                                                                    <Tooltip key={index} title={`Video ${index + 1}`}>
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(url)}>
                                                                            <GetAppOutlinedIcon />
                                                                        </span>
                                                                    </Tooltip>
                                                                ))}
                                                            </div>
                                                        ) : `-`}
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='18b'>
                                                    <TableCell>Execution Completion Photos</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.photoUrls && projectDetails.photoUrls.length > 0 ? (
                                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                                {projectDetails.photoUrls.map((url, index) => (
                                                                    <Tooltip key={index} title={`Photo ${index + 1}`}>
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(url)}>
                                                                            <GetAppOutlinedIcon />
                                                                        </span>
                                                                    </Tooltip>
                                                                ))}
                                                            </div>
                                                        ) : `-`}
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='18c'>
                                                    <TableCell>Execution Completion Whatsapp Chat Images</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.whatsappUrls && projectDetails.whatsappUrls.length > 0 ? (
                                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                                {projectDetails.whatsappUrls.map((url, index) => (
                                                                    <Tooltip key={index} title={`WhatsApp Screenshot ${index + 1}`}>
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(url)}>
                                                                            <GetAppOutlinedIcon />
                                                                        </span>
                                                                    </Tooltip>
                                                                ))}
                                                            </div>
                                                        ) : `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='18d'>
                                                    <TableCell>Execution Completion Certificate</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.completionCertificate ? (
                                                            <Tooltip title="Download Certificate">
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails.completionCertificate)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            </Tooltip>
                                                        ) : `-`}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        </Paper>
                    </Grid>

                    {/* Notes Details */}
                    <Grid item lg={6} md={6} sm={12}>
                        {projectLogs?.map((data, i) => (
                            <Paper className={classes.paper} key={i + 1}>
                                {
                                    data?.dealActivity && <Accordion defaultExpanded className="accordian">
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography className={classes.heading}>
                                                <LocalActivityIcon />
                                                <span className="titlename">Deal Activity</span>
                                                <span className="datedata">{moment(data?.createdAt).format('lll')}</span>
                                                {/* {{pl.createdAt | date}}, {{pl.createdAt | date:'shortTime' }}  */}
                                            </Typography>
                                        </AccordionSummary>
                                        <Divider />
                                        <AccordionDetails>
                                            <Typography variant="body2" gutterBottom>
                                                {maskPhoneNumbersInLogText(data?.dealActivity, customerContactNo)}
                                                {data?.isWhatsAppNotificationSent && (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleViewClick(data)}
                                                        // style={{ marginLeft: '8px' }}
                                                        className={classes.viewButton}
                                                        size="small"
                                                    >
                                                        View
                                                    </Button>
                                                )}
                                            </Typography>
                                        </AccordionDetails>
                                        <Divider />
                                        <AccordionActions style={{ display: "block" }}>
                                            <InfoIcon style={{ cursor: 'pointer' }} onClick={() => showInfo(i, 'dealActivity')} />
                                            {
                                                Array.isArray(data.s3Location) &&
                                                data.s3Location.every(item => Array.isArray(item) ? item.length > 0 : item && item !== "") && (
                                                    <>
                                                        {data.s3Location.map((location, index) => (
                                                            location && location !== "" && !(Array.isArray(location) && location.length === 0) && (
                                                                <AttachmentIcon
                                                                    key={index}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => downloadNotesFile(location)}
                                                                />
                                                            )
                                                        ))}
                                                    </>
                                                )
                                            }
                                        </AccordionActions>
                                    </Accordion >
                                }
                                {
                                    data?.notes && <Accordion defaultExpanded className="accordian">
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography className={classes.heading}>
                                                <EditTwoToneIcon />
                                                <span className="titlename">Notes</span>
                                                <span className="datedata">{moment(data?.createdAt).format('lll')}</span>
                                            </Typography>
                                        </AccordionSummary>
                                        <Divider />
                                        <AccordionDetails>
                                            <Typography variant="body2" gutterBottom>
                                                {maskPhoneNumbersInLogText(data?.notes, customerContactNo)} <br /> <span style={{ fontSize: "12px" }}>{data?.createdBy?.name} has left a note</span>
                                            </Typography>
                                        </AccordionDetails>
                                        <Divider />
                                        <AccordionActions style={{ display: "block" }}>
                                            <InfoIcon style={{ cursor: 'pointer' }} onClick={() => showInfo(i, 'notes')} />
                                            {Array.isArray(data.s3Location) &&
                                                data.s3Location.every(item => Array.isArray(item) ? item.length > 0 : item && item !== "") && (
                                                    <>
                                                        {data.s3Location.map((location, index) => (
                                                            location && location !== "" && !(Array.isArray(location) && location.length === 0) && (
                                                                <AttachmentIcon
                                                                    key={index}
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => downloadNotesFile(location)}
                                                                />
                                                            )
                                                        ))}
                                                    </>
                                                )
                                            }
                                            {/* {data.s3Location.length !== 0 && <AttachmentIcon onClick={() => window.open(data.s3Location[0])} />} */}
                                        </AccordionActions>
                                    </Accordion>
                                }
                            </Paper>
                        ))}
                    </Grid>
                </Grid>
            </div>

            {/* Show Notes and Deal Activity Info Modal */}
            <Dialog open={openNotesInfoModal} onClose={() => setOpenNotesInfoModal(false)} aria-labelledby="form-dialog-title" fullWidth maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    {(stageInfo === 'Quotation Sent' && openActivity === 'dealActivity') && <>Quotation Sent</>}
                    {(stageInfo === 'Requirements Not Collected' && openActivity === 'dealActivity') && <>Requirements Not Collected</>}
                    {(stageInfo === 'Requirements Collected' && openActivity === 'dealActivity') && <>Requirements Collected</>}
                    {(stageInfo === 'Negotiation' && openActivity === 'dealActivity') && <>Negotiation</>}
                    {(stageInfo === 'Won' && openActivity === 'dealActivity') && <>Won</>}
                    {(stageInfo === 'Site/Office visit' && openActivity === 'dealActivity') && <>Site/Office visit</>}
                    {openActivity === 'notes' && <>Notes</>}
                    {(stageInfo !== 'Requirements Not Collected' && stageInfo !== 'Requirements Collected' && stageInfo !== 'Quotation Sent' && stageInfo !== 'Site/Office visit' && stageInfo !== 'Negotiation' && stageInfo !== 'Won' && openActivity === 'dealActivity') && <>Deal Activity</>}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {projectLogs[stageIndex]?.['quotationSentDate'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Quotation sent Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['quotationSentDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>MOM</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momQuotationStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.['preSalesCallDate'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Requirements Not Collected Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['preSalesCallDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.['salesCallDate'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Requirements Collected Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['salesCallDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>Requirements</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['requirements']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Estimated Budget</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['estimatedBudget']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Requirements Collected Comment</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['salesCallComment']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='6'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.['negotiationDate'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Negotiation Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['negotiationDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>MOM Negotitation Stage</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momNegotitationStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='6'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='7'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='8'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.['Won'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Won Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['closureDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>Remarks</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['remark']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Payment Plan</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['paymentPlan']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Final Quote Attached</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['finalQuoteAttached'] === true ? `Yes` : `No`}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Client Move in Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['clientMoveinDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.['siteVisitDate'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Site/Visit Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['siteVisitDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>MOM Meeting Stage</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momMeetingStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>MOM Site Visit Stage</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momSiteVisitStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='6'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }

                    {
                        (
                            stageInfo !== 'Requirements Not Collected' &&
                            stageInfo !== 'Requirements Collected' &&
                            stageInfo !== 'Negotiation' &&
                            stageInfo !== 'Quotation Sent' &&
                            stageInfo !== 'Site/Office visit' &&
                            stageInfo !== 'Won' &&
                            !projectLogs[stageIndex]?.['notes']
                        )
                            ?
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="customized table">
                                    <TableBody>
                                        <TableRow key='1'>
                                            <TableCell>Assigned To</TableCell>
                                            <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                        </TableRow>
                                        <TableRow key='4'>
                                            <TableCell>Department</TableCell>
                                            <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                        </TableRow>
                                        <TableRow key='5'>
                                            <TableCell>Team</TableCell>
                                            <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            :
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="customized table">
                                    <TableBody>
                                        {
                                            projectLogs[stageIndex]?.['notes'] &&

                                            <TableRow key='2'>
                                                <TableCell>Notes</TableCell>
                                                <TableCell>{projectLogs[stageIndex]?.['notes']}</TableCell>
                                            </TableRow>
                                        }
                                        {
                                            projectLogs[stageIndex]?.['s3Location'].length !== 0 &&

                                            <TableRow key='3'>
                                                <TableCell>Attachments</TableCell>
                                                {projectLogs[stageIndex]?.['s3Location']?.map((data, i) => (
                                                    <TableCell key={i + 1}>{data}</TableCell>
                                                ))}
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                    }
                    {
                        (
                            projectLogs[stageIndex]?.['quotationSentDate'] === null ||
                            projectLogs[stageIndex]?.['preSalesCallDate'] === null ||
                            projectLogs[stageIndex]?.['salesCallDate'] === null ||
                            projectLogs[stageIndex]?.['negotiationDate'] === null ||
                            projectLogs[stageIndex]?.['siteVisitDate'] === null
                        )
                        &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>Notes</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['notes']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Attachments</TableCell>
                                        {projectLogs[stageIndex]?.['s3Location']?.map((data, i) => (
                                            <TableCell key={i + 1}>{data}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </DialogContent>
            </Dialog>

            {/* Show whatsApp Notification Content */}
            <Dialog open={openWhatsAppNotificationContentDialog} onClose={() => { setOpenWhatsAppNotificationContentDialog(false); setWhatsAppNotificationContent('') }}>
                <DialogTitle>
                    <Box display="flex" justifyContent="center">
                        <Typography variant="h6" align="center">
                            WhatsApp Notification Content
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MessageComponent name={maskedCustomerName} message={whatsAppNotificationContent} />
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Create Notes Modal */}
            <Dialog open={openNotesModal} onClose={() => setOpenNotesModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Create Notes</DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15 }}>
                        <div className="editor">
                            <Editor
                                editorKey={'editor'}
                                editorState={editorState}
                                onChange={setEditorStateData}
                                plugins={plugins}
                                ref={editorRef}
                            />
                            <MentionSuggestions
                                open={mentionOpen}
                                onOpenChange={onOpenChange}
                                suggestions={suggestions}
                                onSearchChange={onSearchChange}
                                onAddMention={onAddMention}
                                onClose={() => { }}
                            />
                        </div>

                    </div>
                    <div style={{ paddingBottom: 15 }}>
                        <TextField
                            id="start_date"
                            label="Set Reminder"
                            name="reminderDate"
                            onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                            type="datetime-local"
                            className={classes.textFieldWidth}
                            size="small"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div style={{ paddingBottom: 15 }}>
                        <input
                            accept="*"
                            ref={createNoteFile}
                            className={classes.input}
                            id="project-document"
                            onChange={uploadCreateNoteImg}
                            type="file"
                        />
                        <label htmlFor="project-document">
                            {
                                fileUploaded && <CheckCircleIcon />
                            }
                        </label>
                    </div>

                    <div style={{ paddingBottom: 15, display: 'flex', alignItems: 'center' }}>
                        <label style={{ marginLeft: 8 }}>Send Note to Client</label>
                        <Checkbox
                            checked={sendNoteToClient}
                            onChange={(e) => setSendNoteToClient(e.target.checked)}
                            color="primary"
                        />
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenNotesModal(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={saveNotes} color="primary">
                        Save Note
                    </Button>
                </DialogActions>
            </Dialog>


            {/* Send Mail to customer */}
            <Dialog open={openMailModel} onClose={() => setOpenMailModel(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Send Email to Customer</DialogTitle>
                <Divider />
                <DialogContent>
                    <TextField
                        id="pending_payment_date"
                        label="Pending Payment Date"
                        name="pendingPaymentDate"
                        onChange={(e) => setSendMailCustomerData({ ...sendMailCustomerData, [e.target.name]: e.target.value })}
                        className={classes.textFieldWidth}
                        type="date"
                        size="small"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                        style={{ marginBottom: 20, textAlign: "center", marginTop: 20 }}
                    />
                    <TextField label="Amount Due" className={classes.textFieldWidth} size="small" style={{ marginBottom: 20, textAlign: "center" }} name="amountDue" onChange={(e) => setSendMailCustomerData({ ...sendMailCustomerData, [e.target.name]: e.target.value })} variant="outlined" />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenMailModel(false)} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={sendEmailToCustomer} color="primary" variant="outlined">
                        Send Email
                    </Button>
                </DialogActions>
            </Dialog>


            {/* customer Payment update model */}
            <Dialog open={openPaymentUpdateModel} onClose={() => setOpenPaymentUpdateModel(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Update Customer Payment</DialogTitle>
                <Divider />
                <DialogContent>
                    <TextField label="Amount" className={classes.textFieldWidth} size="small" style={{ marginBottom: 20, textAlign: "center" }} name="amount" onChange={(e) => setSendPaymentUpdateData({ ...sendPaymentUpdateData, [e.target.name]: e.target.value })} variant="outlined" />
                    <br />
                    <div style={{ paddingBottom: 15, paddingTop: 10, display: 'inline-flex' }} variant="outlined" size="small">
                        <input
                            accept="*"
                            className={classes.input}
                            id="paymentAttachement-document"
                            onChange={(e) => uploadWDFileDocument(e, 'paymentReceived')}
                            type="file"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="paymentAttachement-document">
                            <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span">
                                Upload Payment Received Attachment
                            </Button>
                        </label>
                        {isFinalPaymentReceived && <CheckCircleIcon style={{ color: "green" }} />}
                    </div>
                    <br />
                    <TextField label="Note" className={classes.textFieldWidth} size="small" style={{ marginBottom: 20, textAlign: "center" }} name="note" onChange={(e) => setSendPaymentUpdateData({ ...sendPaymentUpdateData, [e.target.name]: e.target.value })} variant="outlined" />
                    <br />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenPaymentUpdateModel(false)} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={updateCustomerPaymentAndSendToFinance} color="primary" variant="outlined">
                        Update Customer Payment
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Move Deal Model window */}
            <Dialog open={moveDealOpen} onClose={() => setMoveDealOpen(false)}>
                <DialogTitle>Change Stage</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label">Select Stage</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedStage}
                                label="Select Stage"
                                variant="outlined"
                                onChange={handleSelectedStageChange}
                            >
                                {departmentStage.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setMoveDealOpen(false)} variant="outlined" color="primary">Cancel</Button>
                    <Button onClick={openAnotherDialog} variant="contained" color="primary">Change</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                classes={{ paper: classes.updateModalPaper }}
                open={openUpdateModel}
                onClose={() => {
                    setOpenUpdateModel(false);
                    resetUpdateModalState();
                }}
                aria-labelledby="form-dialog-title"
                maxWidth='sm'
                fullWidth
                TransitionComponent={Grow}
                transitionDuration={250}
            >
                <div className={classes.updateModalHeader}>
                    <div className={classes.updateModalHeaderIcon}>
                        <AssignmentTurnedInIcon />
                    </div>
                    <div>
                        <Typography id="form-dialog-title" className={classes.updateModalHeaderTitle}>
                            Update Execution Status
                        </Typography>
                        <Typography className={classes.updateModalHeaderSubtitle}>
                            Move this project to the next stage and attach the required documents
                        </Typography>
                    </div>
                    <IconButton
                        className={classes.updateModalCloseBtn}
                        size="small"
                        aria-label="close"
                        onClick={() => {
                            setOpenUpdateModel(false);
                            resetUpdateModalState();
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContent className={classes.updateModalContent}>
                    <div
                        className={classes.updateModalFormWrap}
                        style={{ opacity: clicked ? 0.6 : 1, pointerEvents: clicked ? 'none' : 'auto' }}
                    >
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label">Select Stage</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={executionStage}
                                label="Select Stage"
                                variant="outlined"
                                onChange={handleExecutionStageChange}
                            >
                                {execution.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row.status}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        {
                            userDetails?.roles?.find(role => role.name === ROLENAME.SeniorOperationManager) && executionStage.status === "Under Execution" && (
                                <Paper elevation={0} className={classes.sectionCard}>
                                    <Typography className={classes.sectionCardTitle}>
                                        <PersonPinIcon fontSize="small" /> Assign Team
                                    </Typography>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <InputLabel id="assign-el-user-select-label">Select EL User</InputLabel>
                                        <Select
                                            labelId="assign-el-user-select-label"
                                            id="assign-el-user-select"
                                            value={selectedElUser}
                                            label="Select EL User"
                                            variant="outlined"
                                            onChange={handleSelectedElUserChange}
                                        >
                                            {elUsersOptions.map((row, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth variant="outlined" size="small" style={{ marginTop: 16 }}>
                                        <InputLabel id="assign-pm-user-select-label">Select PM</InputLabel>
                                        <Select
                                            labelId="assign-pm-user-select-label"
                                            id="assign-pm-user-select"
                                            value={selectedPmUser}
                                            label="Select PM"
                                            variant="outlined"
                                            onChange={handleSelectedPmUserChange}
                                        >
                                            {pmUsersOptions.map((row, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Paper>
                            )
                        }
                        {
                            executionStage.status === "Completed-MWP" && (
                                <Paper elevation={0} className={classes.sectionCard}>
                                    {/* <Typography
                                    variant="subtitle1"
                                    style={{
                                        fontWeight: 500,
                                        marginBottom: 15
                                    }}
                                >
                                    Completion & Handover Certificate
                                </Typography>

                                <input
                                    accept="application/pdf"
                                    style={{ display: "none" }}
                                    id="completion-pdf-upload"
                                    type="file"
                                    onChange={handleFileChange}
                                />

                                <label htmlFor="completion-pdf-upload">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                        startIcon={<CloudUploadIcon />}
                                        fullWidth
                                    >
                                        {file ? "Replace PDF" : "Upload PDF"}
                                    </Button>
                                </label>

                                {file && (
                                    <Paper
                                        variant="outlined"
                                        style={{
                                            marginTop: 10,
                                            padding: 10,
                                            background: "#f5f5f5",
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            style={{ color: "#F47E44" }}
                                        >
                                            📄 {file.name}
                                        </Typography>
                                    </Paper>
                                )}

                                <Button
                                    variant="outlined"
                                    color="primary"
                                    fullWidth
                                    style={{ marginTop: 15 }}
                                    disabled={!file || loading}
                                    onClick={handleExtract}
                                >
                                    {loading ? "Extracting..." : "Extract Data"}
                                </Button> */}

                                    <Typography className={classes.sectionCardTitle} style={{ marginBottom: 14 }}>
                                        <DescriptionIcon fontSize="small" /> Completion Certificate
                                    </Typography>

                                    <input
                                        type="file"
                                        onChange={uploadCompletionCertificate}
                                        style={{ display: 'none' }}
                                        id="certificate-upload-input"
                                        accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                                        disabled={certificateUploading}
                                    />
                                    <div className={classes.uploadRow}>
                                        <label htmlFor="certificate-upload-input">
                                            <Button
                                                variant="contained"
                                                component="span"
                                                color="primary"
                                                disabled={certificateUploading}
                                                startIcon={certificateUploading ? <CircularProgress size={16} thickness={5} style={{ color: '#fff' }} /> : <DescriptionIcon />}
                                                className={classes.uploadButtonPill}
                                                style={{ background: "#F47E44" }}
                                            >
                                                {certificateUploading ? "Uploading..." : (completionCertificate ? "Replace Completion Certificate" : "Upload Completion Certificate")}
                                            </Button>
                                        </label>

                                        {completionCertificate && !certificateUploading && (
                                            <CheckCircleIcon style={{ color: 'green', fontSize: 26 }} />
                                        )}
                                    </div>
                                    {/* Customer OTP is not required at the Completed-MWP stage - only
                                    at final "Completed" handover (see the "Completed" section below). */}
                                    {loading && (
                                        <Paper
                                            elevation={0}
                                            style={{
                                                marginTop: 20,
                                                padding: 20,
                                                borderRadius: 16,
                                                textAlign: "center",
                                                background: "#f5f7fb",
                                            }}
                                        >
                                            <CircularProgress size={35} />

                                            <Typography
                                                variant="subtitle1"
                                                style={{ marginTop: 10 }}
                                            >
                                                Validating Completion Certificate...
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                Checking mandatory fields and signatures
                                            </Typography>
                                        </Paper>
                                    )}
                                    {extractResponse && (
                                        <Paper
                                            elevation={3}
                                            style={{
                                                marginTop: 20,
                                                padding: 20,
                                                borderRadius: 16,
                                            }}
                                        >
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Completion Certificate Analysis
                                            </Typography>

                                            <Divider style={{ marginBottom: 16 }} />

                                            {/* Status */}
                                            <Alert
                                                severity={
                                                    extractResponse?.isValidDocument
                                                        ? "success"
                                                        : "error"
                                                }
                                                style={{ marginBottom: 16 }}
                                            >
                                                <Typography variant="subtitle2">
                                                    {extractResponse?.isValidDocument
                                                        ? "Document validation successful"
                                                        : "Document validation failed"}
                                                </Typography>
                                            </Alert>

                                            {/* Re-upload Instruction */}
                                            {(!extractResponse?.isValidDocument &&
                                                extractResponse?.missingFields?.length > 0 &&
                                                extractResponse?.validationErrors?.length > 0) && (
                                                    <Alert
                                                        severity="warning"
                                                        style={{
                                                            marginBottom: 16,
                                                            borderLeft: "4px solid #ff9800",
                                                        }}
                                                    >
                                                        <Typography variant="body2">
                                                            <strong>Action Required:</strong> Some mandatory fields are missing or invalid.
                                                            Please correct the document and upload it again using the same Upload PDF button.
                                                        </Typography>
                                                    </Alert>
                                                )}

                                            {/* Confidence */}
                                            <Box mb={2}>
                                                <Typography
                                                    variant="subtitle2"
                                                    gutterBottom
                                                >
                                                    Confidence Score
                                                </Typography>

                                                <Chip
                                                    label={`${extractResponse?.confidence || 0}%`}
                                                    style={{
                                                        backgroundColor:
                                                            extractResponse?.confidence >= 95
                                                                ? "#4caf50"
                                                                : extractResponse?.confidence >= 60
                                                                    ? "#ff9800"
                                                                    : "#f44336",
                                                        color: "#fff",
                                                    }}
                                                />
                                            </Box>

                                            {/* Missing Fields */}
                                            {extractResponse?.missingFields?.length > 0 && (
                                                <Box mb={3}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        color="error"
                                                        gutterBottom
                                                    >
                                                        Missing Mandatory Fields ({extractResponse.missingFields.length})
                                                    </Typography>

                                                    <Box
                                                        display="flex"
                                                        flexWrap="wrap"
                                                        style={{
                                                            gap: 8,
                                                            marginTop: 8,
                                                        }}
                                                    >
                                                        {extractResponse.missingFields.map(
                                                            (field) => (
                                                                <Chip
                                                                    key={field}
                                                                    label={field
                                                                        .replace(/([A-Z])/g, " $1")
                                                                        .replace(/^./, (str) =>
                                                                            str.toUpperCase()
                                                                        )}
                                                                    color="secondary"
                                                                    variant="outlined"
                                                                />
                                                            )
                                                        )}
                                                    </Box>
                                                </Box>
                                            )}

                                            {/* Validation Errors */}
                                            {extractResponse?.validationErrors?.length > 0 && (
                                                <Box mb={3}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        color="error"
                                                        gutterBottom
                                                    >
                                                        Validation Errors
                                                    </Typography>

                                                    {extractResponse.validationErrors.map(
                                                        (error, index) => (
                                                            <Alert
                                                                key={index}
                                                                severity="warning"
                                                                style={{
                                                                    marginBottom: 8,
                                                                }}
                                                            >
                                                                {error}
                                                            </Alert>
                                                        )
                                                    )}
                                                </Box>
                                            )}

                                            {/* Extracted Data */}
                                            {/* <Typography
                                            variant="subtitle1"
                                            gutterBottom
                                        >
                                            Extracted Information
                                        </Typography>

                                        <Grid container spacing={2}>
                                            {Object.entries(
                                                extractResponse?.extractedData || {}
                                            ).map(([key, field]) => {
                                                const isMissing =
                                                    extractResponse?.missingFields?.includes(
                                                        key
                                                    );

                                                return (
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        md={4}
                                                        key={key}
                                                    >
                                                        <Paper
                                                            variant="outlined"
                                                            style={{
                                                                padding: 12,
                                                                height: "100%",
                                                                border: isMissing
                                                                    ? "1px solid #f44336"
                                                                    : undefined,
                                                                backgroundColor: isMissing
                                                                    ? "#fff5f5"
                                                                    : "#fff",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="caption"
                                                                color="textSecondary"
                                                            >
                                                                {key
                                                                    .replace(/([A-Z])/g, " $1")
                                                                    .replace(/^./, (str) =>
                                                                        str.toUpperCase()
                                                                    )}
                                                            </Typography>

                                                            <Typography
                                                                variant="body1"
                                                                style={{
                                                                    marginTop: 4,
                                                                    fontWeight: 500,
                                                                    color: isMissing
                                                                        ? "#d32f2f"
                                                                        : "inherit",
                                                                }}
                                                            >
                                                                {typeof field?.value ===
                                                                    "boolean"
                                                                    ? field.value
                                                                        ? "✓ Present"
                                                                        : "✗ Missing"
                                                                    : field?.value || "✗ Missing"}
                                                            </Typography>

                                                            {field?.confidence !==
                                                                undefined && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="textSecondary"
                                                                    >
                                                                        Confidence:{" "}
                                                                        {field.confidence}%
                                                                    </Typography>
                                                                )}
                                                        </Paper>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid> */}
                                        </Paper>
                                    )}
                                </Paper>
                            )
                        }
                        {executionStage.status === "Completed" && (
                            <Paper elevation={0} className={classes.sectionCard} style={{ marginBottom: 20 }}>
                                <Typography className={classes.sectionCardTitle}>
                                    <AssignmentTurnedInIcon fontSize="small" /> Execution Completion Details
                                </Typography>

                                <TextField
                                    id="Execution-Completion-Remarks"
                                    label="Execution Completion Remarks"
                                    name="Execution Completion Remarks"
                                    onChange={(e) => setExecutionCompletionRemarks(e.target.value)}
                                    className={classes.textFieldWidth}
                                    type="text"
                                    size="small"
                                    variant="outlined"
                                    fullWidth
                                />

                                {/* Completion Certificate Section */}
                                <Divider style={{ margin: '24px 0' }} />
                                <Typography className={classes.subSectionTitle}>
                                    <DescriptionIcon fontSize="small" /> Completion Certificate
                                </Typography>

                                <input
                                    type="file"
                                    onChange={uploadCompletionCertificate}
                                    style={{ display: 'none' }}
                                    id="certificate-upload-input"
                                    accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                                    disabled={certificateUploading}
                                />
                                <div className={classes.uploadRow}>
                                    <label htmlFor="certificate-upload-input">
                                        <Button
                                            variant="contained"
                                            component="span"
                                            color="primary"
                                            disabled={certificateUploading}
                                            startIcon={certificateUploading ? <CircularProgress size={16} thickness={5} style={{ color: '#fff' }} /> : <DescriptionIcon />}
                                            className={classes.uploadButtonPill}
                                            style={{ background: "#F47E44" }}
                                        >
                                            {certificateUploading ? "Uploading..." : (completionCertificate ? "Replace Completion Certificate" : "Upload Completion Certificate")}
                                        </Button>
                                    </label>

                                    {completionCertificate && !certificateUploading && (
                                        <CheckCircleIcon style={{ color: 'green', fontSize: 26 }} />
                                    )}
                                </div>
                                {completionCertificate && renderCertificateOtpSection()}

                                {/* Multiple Photos Upload Section */}
                                <Divider style={{ margin: '24px 0' }} />
                                <Typography className={classes.subSectionTitle}>
                                    <PhotoLibraryIcon fontSize="small" /> Multiple Photos Upload
                                </Typography>

                                {photoInputs.map((input, index) => (
                                    <div key={`photo-${input.id}`}>
                                        <div className={classes.uploadRow}>
                                            <input
                                                type="file"
                                                accept=".jpg, .png, .jpeg"
                                                id={`photo-upload-${input.id}`}
                                                onChange={(event) => uploadPhoto(event, index, input.id)}
                                                style={{ display: 'none' }}
                                                disabled={Boolean(photoUploadingIds[input.id])}
                                            />
                                            <label htmlFor={`photo-upload-${input.id}`}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    disabled={Boolean(photoUploadingIds[input.id])}
                                                    startIcon={photoUploadingIds[input.id] ? <CircularProgress size={16} thickness={5} style={{ color: '#fff' }} /> : <PhotoIcon />}
                                                    className={classes.uploadButtonPill}
                                                    style={{ background: "#F47E44" }}
                                                >
                                                    {photoUploadingIds[input.id] ? "Uploading..." : `Upload Photo ${index + 1}`}
                                                </Button>
                                            </label>

                                            {photoUrls[index] && !photoUploadingIds[input.id] && (
                                                <CheckCircleIcon style={{ color: 'green', fontSize: 26 }} />
                                            )}

                                            <div style={{ marginLeft: 'auto', display: 'flex' }}> {/* Push action buttons to the right */}
                                                <Tooltip title="Add another photo">
                                                    <IconButton
                                                        className={classes.iconCircleBtn}
                                                        size="small"
                                                        onClick={handleAddPhotoInput}
                                                    >
                                                        <AddCircleOutlineRoundedIcon style={{ color: "#F47E44" }} />
                                                    </IconButton>
                                                </Tooltip>

                                                {index !== 0 && (
                                                    <Tooltip title="Remove this photo">
                                                        <IconButton
                                                            className={classes.iconCircleBtn}
                                                            size="small"
                                                            disabled={Boolean(photoUploadingIds[input.id])}
                                                            onClick={() => handleRemovePhotoInput(input.id)}
                                                        >
                                                            <DeleteOutlineOutlinedIcon color="error" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* Multiple Videos Upload Section */}
                                <Divider style={{ margin: '24px 0' }} />
                                <Typography className={classes.subSectionTitle}>
                                    <VideoLibraryIcon fontSize="small" /> Multiple Videos Upload
                                </Typography>

                                {videoInputs.map((input, index) => (
                                    <div key={`video-${input.id}`}>
                                        <div className={classes.uploadRow}>
                                            <input
                                                type="file"
                                                accept="video/*"
                                                id={`video-upload-${input.id}`}
                                                onChange={(event) => uploadVideo(event, index, input.id)}
                                                style={{ display: 'none' }}
                                                disabled={Boolean(videoUploadingIds[input.id])}
                                            />
                                            <label htmlFor={`video-upload-${input.id}`}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    disabled={Boolean(videoUploadingIds[input.id])}
                                                    startIcon={videoUploadingIds[input.id] ? <CircularProgress size={16} thickness={5} style={{ color: '#fff' }} /> : <VideoLibraryIcon />}
                                                    className={classes.uploadButtonPill}
                                                    style={{ background: "#F47E44" }}
                                                >
                                                    {videoUploadingIds[input.id] ? "Uploading..." : `Upload Video ${index + 1}`}
                                                </Button>
                                            </label>

                                            {videoUrls[index] && !videoUploadingIds[input.id] && (
                                                <CheckCircleIcon style={{ color: 'green', fontSize: 26 }} />
                                            )}

                                            <div style={{ marginLeft: 'auto', display: 'flex' }}> {/* Push action buttons to the right */}
                                                <Tooltip title="Add another video">
                                                    <IconButton
                                                        className={classes.iconCircleBtn}
                                                        size="small"
                                                        onClick={handleAddVideoInput}
                                                    >
                                                        <AddCircleOutlineRoundedIcon style={{ color: "#F47E44" }} />
                                                    </IconButton>
                                                </Tooltip>

                                                {index !== 0 && (
                                                    <Tooltip title="Remove this video">
                                                        <IconButton
                                                            className={classes.iconCircleBtn}
                                                            size="small"
                                                            disabled={Boolean(videoUploadingIds[input.id])}
                                                            onClick={() => handleRemoveVideoInput(input.id)}
                                                        >
                                                            <DeleteOutlineOutlinedIcon color="error" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                {/* WhatsApp Group Chat Screenshots Section */}
                                <Divider style={{ margin: '24px 0' }} />
                                <Typography className={classes.subSectionTitle}>
                                    <ChatIcon fontSize="small" /> WhatsApp Group Chat Screenshots
                                </Typography>

                                {whatsappInputs.map((input, index) => (
                                    <div key={`whatsapp-${input.id}`}>
                                        <div className={classes.uploadRow}>
                                            <input
                                                type="file"
                                                accept=".jpg, .png, .jpeg"
                                                id={`whatsapp-screenshot-${input.id}`}
                                                onChange={(event) => uploadWhatsappScreenshot(event, index, input.id)}
                                                style={{ display: 'none' }}
                                                disabled={Boolean(whatsappUploadingIds[input.id])}
                                            />
                                            <label htmlFor={`whatsapp-screenshot-${input.id}`}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    component="span"
                                                    disabled={Boolean(whatsappUploadingIds[input.id])}
                                                    startIcon={whatsappUploadingIds[input.id] ? <CircularProgress size={16} thickness={5} style={{ color: '#fff' }} /> : <AttachFileIcon />}
                                                    className={classes.uploadButtonPill}
                                                    style={{ background: "#F47E44" }}
                                                >
                                                    {whatsappUploadingIds[input.id] ? "Uploading..." : `Upload WhatsApp Screenshot ${index + 1}`}
                                                </Button>
                                            </label>

                                            {whatsappUrls[index] && !whatsappUploadingIds[input.id] && (
                                                <CheckCircleIcon style={{ color: 'green', fontSize: 26 }} />
                                            )}

                                            <div style={{ marginLeft: 'auto', display: 'flex' }}> {/* Push action buttons to the right */}
                                                <Tooltip title="Add another screenshot">
                                                    <IconButton
                                                        className={classes.iconCircleBtn}
                                                        size="small"
                                                        onClick={handleAddWhatsappInput}
                                                    >
                                                        <AddCircleOutlineRoundedIcon style={{ color: "#F47E44" }} />
                                                    </IconButton>
                                                </Tooltip>

                                                {index !== 0 && (
                                                    <Tooltip title="Remove this screenshot">
                                                        <IconButton
                                                            className={classes.iconCircleBtn}
                                                            size="small"
                                                            disabled={Boolean(whatsappUploadingIds[input.id])}
                                                            onClick={() => handleRemoveWhatsappInput(input.id)}
                                                        >
                                                            <DeleteOutlineOutlinedIcon color="error" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/* <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: 500,
                                    marginBottom: 15
                                }}
                            >
                                Completion & Handover Certificate
                            </Typography>

                            <input
                                accept="application/pdf"
                                style={{ display: "none" }}
                                id="completion-pdf-upload"
                                type="file"
                                onChange={handleFileChange}
                            />

                            <label htmlFor="completion-pdf-upload">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    component="span"
                                    startIcon={<CloudUploadIcon />}
                                    fullWidth
                                >
                                    {file ? "Replace PDF" : "Upload PDF"}
                                </Button>
                            </label> */}
                                {file && (
                                    <Paper
                                        variant="outlined"
                                        style={{
                                            marginTop: 10,
                                            padding: 10,
                                            background: "#f5f5f5",
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            style={{ color: "#F47E44" }}
                                        >
                                            📄 {file.name}
                                        </Typography>
                                    </Paper>
                                )}

                                {/* <Button
                                variant="outlined"
                                color="primary"
                                fullWidth
                                style={{ marginTop: 15 }}
                                disabled={!file || loading}
                                onClick={handleExtract}
                            >
                                {loading ? "Extracting..." : "Extract Data"}
                            </Button> */}
                                {loading && (
                                    <Paper
                                        elevation={0}
                                        style={{
                                            marginTop: 20,
                                            padding: 20,
                                            borderRadius: 16,
                                            textAlign: "center",
                                            background: "#f5f7fb",
                                        }}
                                    >
                                        <CircularProgress size={35} />

                                        <Typography
                                            variant="subtitle1"
                                            style={{ marginTop: 10 }}
                                        >
                                            Validating Completion Certificate...
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            Checking mandatory fields and signatures
                                        </Typography>
                                    </Paper>
                                )}
                                {extractResponse && (
                                    <Paper
                                        elevation={3}
                                        style={{
                                            marginTop: 20,
                                            padding: 20,
                                            borderRadius: 8,
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            gutterBottom
                                        >
                                            Completion Certificate Analysis
                                        </Typography>

                                        <Divider style={{ marginBottom: 16 }} />

                                        {/* Status */}
                                        <Alert
                                            severity={
                                                extractResponse?.isValidDocument
                                                    ? "success"
                                                    : "error"
                                            }
                                            style={{ marginBottom: 16 }}
                                        >
                                            <Typography variant="subtitle2">
                                                {extractResponse?.isValidDocument
                                                    ? "Document validation successful"
                                                    : "Document validation failed"}
                                            </Typography>
                                        </Alert>

                                        {/* Re-upload Instruction */}
                                        {(!extractResponse?.isValidDocument &&
                                            extractResponse?.missingFields?.length > 0 &&
                                            extractResponse?.validationErrors?.length > 0) && (
                                                <Alert
                                                    severity="warning"
                                                    style={{
                                                        marginBottom: 16,
                                                        borderLeft: "4px solid #ff9800",
                                                    }}
                                                >
                                                    <Typography variant="body2">
                                                        <strong>Action Required:</strong> Some mandatory fields are missing or invalid.
                                                        Please correct the document and upload it again using the same Upload PDF button.
                                                    </Typography>
                                                </Alert>
                                            )}

                                        {/* Confidence */}
                                        <Box mb={2}>
                                            <Typography
                                                variant="subtitle2"
                                                gutterBottom
                                            >
                                                Confidence Score
                                            </Typography>

                                            <Chip
                                                label={`${extractResponse?.confidence || 0}%`}
                                                style={{
                                                    backgroundColor:
                                                        extractResponse?.confidence >= 95
                                                            ? "#4caf50"
                                                            : extractResponse?.confidence >= 60
                                                                ? "#ff9800"
                                                                : "#f44336",
                                                    color: "#fff",
                                                }}
                                            />
                                        </Box>

                                        {/* Missing Fields */}
                                        {extractResponse?.missingFields?.length > 0 && (
                                            <Box mb={3}>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="error"
                                                    gutterBottom
                                                >
                                                    Missing Mandatory Fields ({extractResponse.missingFields.length})
                                                </Typography>

                                                <Box
                                                    display="flex"
                                                    flexWrap="wrap"
                                                    style={{
                                                        gap: 8,
                                                        marginTop: 8,
                                                    }}
                                                >
                                                    {extractResponse.missingFields.map(
                                                        (field) => (
                                                            <Chip
                                                                key={field}
                                                                label={field
                                                                    .replace(/([A-Z])/g, " $1")
                                                                    .replace(/^./, (str) =>
                                                                        str.toUpperCase()
                                                                    )}
                                                                color="secondary"
                                                                variant="outlined"
                                                            />
                                                        )
                                                    )}
                                                </Box>
                                            </Box>
                                        )}

                                        {/* Validation Errors */}
                                        {extractResponse?.validationErrors?.length > 0 && (
                                            <Box mb={3}>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="error"
                                                    gutterBottom
                                                >
                                                    Validation Errors
                                                </Typography>

                                                {extractResponse.validationErrors.map(
                                                    (error, index) => (
                                                        <Alert
                                                            key={index}
                                                            severity="warning"
                                                            style={{
                                                                marginBottom: 8,
                                                            }}
                                                        >
                                                            {error}
                                                        </Alert>
                                                    )
                                                )}
                                            </Box>
                                        )}

                                        {/* Extracted Data */}
                                        {/* <Typography
                                        variant="subtitle1"
                                        gutterBottom
                                    >
                                        Extracted Information
                                    </Typography>

                                    <Grid container spacing={2}>
                                        {Object.entries(
                                            extractResponse?.extractedData || {}
                                        ).map(([key, field]) => {
                                            const isMissing =
                                                extractResponse?.missingFields?.includes(
                                                    key
                                                );

                                            return (
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={6}
                                                    md={4}
                                                    key={key}
                                                >
                                                    <Paper
                                                        variant="outlined"
                                                        style={{
                                                            padding: 12,
                                                            height: "100%",
                                                            border: isMissing
                                                                ? "1px solid #f44336"
                                                                : undefined,
                                                            backgroundColor: isMissing
                                                                ? "#fff5f5"
                                                                : "#fff",
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="caption"
                                                            color="textSecondary"
                                                        >
                                                            {key
                                                                .replace(/([A-Z])/g, " $1")
                                                                .replace(/^./, (str) =>
                                                                    str.toUpperCase()
                                                                )}
                                                        </Typography>

                                                        <Typography
                                                            variant="body1"
                                                            style={{
                                                                marginTop: 4,
                                                                fontWeight: 500,
                                                                color: isMissing
                                                                    ? "#d32f2f"
                                                                    : "inherit",
                                                            }}
                                                        >
                                                            {typeof field?.value ===
                                                                "boolean"
                                                                ? field.value
                                                                    ? "✓ Present"
                                                                    : "✗ Missing"
                                                                : field?.value || "✗ Missing"}
                                                        </Typography>

                                                        {field?.confidence !==
                                                            undefined && (
                                                                <Typography
                                                                    variant="caption"
                                                                    color="textSecondary"
                                                                >
                                                                    Confidence:{" "}
                                                                    {field.confidence}%
                                                                </Typography>
                                                            )}
                                                    </Paper>
                                                </Grid>
                                            );
                                        })}
                                    </Grid> */}
                                    </Paper>
                                )}
                            </Paper>
                        )}
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions className={classes.updateModalActions}>
                    <Button
                        onClick={() => {
                            setOpenUpdateModel(false);
                            resetUpdateModalState();
                        }}
                        color="secondary"
                        variant="outlined"
                        className={classes.secondaryActionBtn}
                    >
                        Cancel
                    </Button>
                    {/* <Button onClick={changeStatusMaterialDispatched} color="primary" variant="outlined"> */}
                    <Button
                        disabled={
                            // clicked || (isCompleted && !extractResponse?.success) ||
                            clicked ||
                            (userDetails?.roles?.find(role => role.name === ROLENAME.SeniorOperationManager) && executionStage.status === "Under Execution" && (!selectedElUser?._id || !selectedPmUser?._id)) ||
                            // OTP is only required for the final "Completed" handover, not "Completed-MWP"
                            (executionStage.status === "Completed" && !certificateOtpVerified)
                        }
                        onClick={changeStatusUnderExecution}
                        color="primary"
                        variant="contained"
                        disableElevation
                        className={classes.primaryActionBtn}
                        startIcon={clicked ? null : (isCompleted ? <SendIcon /> : null)}
                    >
                        {clicked
                            ? (
                                <>
                                    <CircularProgress size={16} thickness={5} style={{ color: '#fff', marginRight: 8 }} />
                                    {isCompleted ? "Sending..." : "Submitting..."}
                                </>
                            )
                            : (isCompleted ? "Send for Approval" : "Submit")
                        }
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Move Deal Model window */}
            <Dialog open={userModel} onClose={() => setUserModel(false)}>
                <DialogTitle>Move Deal</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label">Select User</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedUser}
                                label="Select User"
                                variant="outlined"
                                onChange={handleSelectedUsersChange}
                            >
                                {usersData.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row}>{row?.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUserModel(false)} variant="outlined" color="primary">Cancel</Button>
                    <Button onClick={updateToNewUser} variant="contained" color="primary">Change</Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for select the details of previous dialog selected stage */}
            <Dialog open={openMoveDealDetailsDialog} onClose={() => setOpenMoveDealDetailsDialog(false)}>
                <DialogTitle>Select Details</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        {/* Select Department */}
                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label">Select Department</InputLabel>
                            <Select
                                labelId="demo-simple-select-label1"
                                id="demo-simple-select1"
                                value={department}
                                label="Select Stage"
                                onChange={handleSelectedDepartmentChange}
                                variant="outlined"
                                size="small"
                            >
                                {departmentLists.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        {/* Select Team */}
                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label2">Select Team</InputLabel>
                            <Select
                                labelId="demo-simple-select-label2"
                                id="demo-simple-select2"
                                value={team}
                                label="Select Team"
                                onChange={handleSelectedTeamChange}
                                variant="outlined"
                                size="small"
                            >
                                {teamLists.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        {/* Select Deal Owner User */}
                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label3">Select User</InputLabel>
                            <Select
                                labelId="demo-simple-select-label3"
                                id="demo-simple-select3"
                                value={dealOwner}
                                label="Select User"
                                onChange={handleSelectedUserChange}
                                variant="outlined"
                                size="small"
                            >
                                {dealOwnerLists.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenMoveDealDetailsDialog(false)} variant="outlined">Cancel</Button>
                    <Button variant="contained" color="primary" onClick={() => assignLeadToUser()}>Assign Project</Button>
                </DialogActions>
            </Dialog>

            {/* Change Stage Status Modal */}
            <Dialog open={openStageStatusModal} onClose={() => setOpenStageStatusModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    Update Stage Staus
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15, marginTop: 15 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label">Select Stage Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedStageStatus}
                                label="Select Stage Status"
                                variant="outlined"
                                onChange={(e) => handleSelectedStageStatus(e)}
                            >
                                <MenuItem key='1' value='Under Production - Machine'>Under Production - Machine</MenuItem>
                                <MenuItem key='2' value='Under Production - Fixing'>Under Production - Fixing</MenuItem>
                                <MenuItem key='3' value='Ready for dispatch'>Ready for dispatch</MenuItem>
                            </Select>
                        </FormControl>
                        {
                            selectedStageStatus === 'Ready for dispatch' &&
                            <FormControl fullWidth style={{ paddingTop: 20 }} variant="outlined" size="small">
                                <TextField
                                    style={{ margin: '5px' }}
                                    id="dispatch-Date"
                                    name="dispatchDate"
                                    value={moment(dispatchDate).format('YYYY-MM-DD')}
                                    onChange={(e) => setDispatchDate(e.target.value)}
                                    label="Ready to dispatch date"
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    variant="outlined"
                                    size="small"
                                />
                            </FormControl>
                        }
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenStageStatusModal(false)} variant="outlined" color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => updateStageStatus()} variant="outlined" color="primary">
                        Update Stage Status
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Update Material Received Status Modal */}
            <Dialog open={openUpdateMaterialStatusModal} onClose={() => setOpenUpdateMaterialStatusModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    Update Material Received Status
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15, marginTop: 15 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="demo-simple-select-label">Select Material Received Status</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedMaterilPercentage}
                                label="Select Stage Status"
                                variant="outlined"
                                onChange={(e) => setSelectedMaterilPercentage(e.target.value)}
                            >
                                <MenuItem key='1' value='Yes'>Yes</MenuItem>
                                <MenuItem key='4' value='No'>No</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenUpdateMaterialStatusModal(false)} variant="outlined" color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => updateMaterialReceived()} variant="outlined" color="primary">
                        Update Material Received Status
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}


export default connect(null, { setLoading, setSnackInfo })(ManageExecutionProjectLogs)